// 2024-10-07T09:50:17.017Z  (1728294617017)
export const locale = {
	lang: 'uk',
	data: {
		'ACCOUNTING_VALUE': 'Облікова вартість',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Розрахунок в станах',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Розрахунок значень',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Розрахунок вартості',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Підсумовування значень',
		'ACCOUNT_ACTIVATION': 'Активація аккаунта',
		'ACCOUNT_ACTIVATION.CODE': 'Код активації',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Надіслати код активації повторно',
		'ACCOUNT_ACTIVATION.INTRO': 'Будь ласка, введіть код активації, який ви отримали по електронній пошті',
		'ACID': 'Кислота.',
		'ACTIVATE': 'Активувати',
		'ACTIVATE.SELECTED': 'Активувати вибрані',
		'ACTIVE': 'Активний',
		'ACTIVITIES.DAILY': 'Денні активності',
		'ACTIVITIES.EXPORT': 'Експортна діяльність',
		'ACTIVITIES.NO': 'Активності відсутні',
		'ACTIVITIES.WEEKLY': 'Активності за тиждень',
		'ACTIVITY': 'Активність',
		'ACTIVITY.EXPORT_DETAILS': 'Експорт обраної активності',
		'ACTIVITY.NO_FIELDS_WORKED': 'Робота на цих полях відсутня',
		'ADAPTER': 'Адаптер',
		'ADAPTER.ASSIGN': 'Призначити адаптер',
		'ADAPTER.ASSIGN.FAILURE': 'Сталася помилка при підключенні адаптера',
		'ADAPTER.ASSIGN.SUCCESS': 'Адаптер успішно призначено',
		'ADAPTER.ASSIGNED_MACHINE': 'Призначена техніка',
		'ADAPTER.ASSIGNMENT': 'Призначення адаптерів до техніки',
		'ADAPTER.CHOSEN': 'Обраний адаптер',
		'ADAPTER.LOAD.FAILURE': 'При завантаженні адаптерів сталася помилка',
		'ADAPTER.NO': 'Адаптер відсутній',
		'ADAPTER.NONE_AVAILABLE': 'Немає доступних адаптерів',
		'ADAPTER.PAIR_INFO': 'Виберіть відповідний адаптер. Вже призначені адаптери будуть перезаписані з новою машиною. Нова конфігурація буде автоматично завантажена при наступному перезапуску адаптера.',
		'ADAPTER.PREVIOUS': 'Попередній адаптер',
		'ADAPTERS.NO': 'Адаптери відсутні',
		'ADBLUE.LEVEL': 'Рівень AdBlue',
		'ADD': 'Додати',
		'ADDITIONAL_VALUE': 'Додаткова вартість',
		'ADDITIVE': 'Добавка',
		'ADDRESS': 'Адреса',
		'ALL': 'Усе.',
		'ALL_DEVICES': 'Загальні пристрої',
		'AMOUNT': 'Сума',
		'AMOUNT.INVALID': 'Сума недійсна',
		'AMOUNTS': 'Суми',
		'APPLY': 'Подати заявку',
		'ARCHIVE': 'Архів',
		'ARCHIVE.SELECTED': 'Архів обраний',
		'AREA': 'Площа',
		'AREA.FIELD': 'Площа',
		'AREA.LOCATION': 'Місцезнаходження району',
		'AREA.PERFORMANCE': 'Площа в годину',
		'AREA.PROCESSED': 'Оброблена площа',
		'AREA.TOTAL': 'Загальна площа',
		'AREA.WORKED': 'Оброблена площа',
		'ASSIGN': 'Призначити',
		'AUTH.REMEMBER_ME': 'Запам ятати мене',
		'BACK': 'Назад',
		'BALES': 'Тюки',
		'BASIC_DATA': 'Основні дані',
		'BEACON': 'Маячок',
		'BEACON.ASSIGN': 'Призначити маячок',
		'BEACON.ASSIGN.SUCCESS': 'Маячок успішно призначено',
		'BEACON.ASSIGNED_EMPLOYEE': 'Призначений співробітник',
		'BEACON.ASSIGNED_IMPLEMENT': 'Призначене обладнання',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Призначити маячок співробітнику',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Призначити маячок обладнанню',
		'BEACON.CHOSEN': 'Обраний маячок',
		'BEACON.ERROR': 'Виникла помилка при з\'єднанні маячка',
		'BEACON.LOAD_ERROR': 'Виникла помилка при завантаженні маячка',
		'BEACON.NONE_AVAILABLE': 'Немає доступного маячка',
		'BEACON.NO_BEACON': 'Маячок відсутній',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Виберіть відповідний маячок. Вже призначені маячки будуть перезаписані з новим співробітником',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Виберіть відповідний маячок. Вже призначені маячки будуть перезаписані з новим обладнанням',
		'BEACON.PREVIOUS': 'Попередній маячок',
		'BEACONS': 'Маячки',
		'BUILD_YEAR': 'Рік випуску',
		'BUILD_YEAR.INVALID': 'Рік виробництва недійсний',
		'CAN.STATUS': 'CAN статус',
		'CANCEL': 'Відмінити',
		'CHANGE': 'Змінити',
		'CHANGE.NO': 'Без змін',
		'CHOOSE_ALL': 'Обрати все',
		'CHOOSE_ROLE': 'Обрати роль',
		'CHRONOLOGICAL': 'хронологічний порядок',
		'CLICK_PROCESS': 'Виберіть дію для отримання більш докладної інформації',
		'CLOSE': 'Закрити',
		'CO2.EMISSION': 'Викид CO2',
		'CO2.PER': 'Кількість СО2 на га',
		'CO2.TOTAL': 'Загальна кількість СО2',
		'COLOR': 'Колір',
		'COMMENT': 'Коментар',
		'CONDITION': 'умова',
		'CONFIRM': 'Підтвердіть',
		'CONFIRM_PASSWORD': 'Підтвердіть пароль',
		'CONNECT': 'З\'єднати',
		'CONTACT_PERSON': 'Контактна особа',
		'CONTINUE': 'Продовжити',
		'COST': 'Вартість',
		'COST.INVALID': 'Недійсна вартість',
		'COST.OVERALL': 'Загальна вартість',
		'COST.OVERALL.ARRIVAL': 'Загальна вартість прибуття',
		'COST.OVERALL.DRIVER': 'Загальний фактор витрат',
		'COST.OVERALL.FIELD_TIME': 'Загальні витрати на місцях',
		'COST.OVERALL.IMPLEMENTS': 'Загальні витрати на знаряддя праці',
		'COST.OVERALL.MACHINES': 'Загальна вартість машин',
		'COST.OVERALL.PREPARATION': 'Загальна підготовка витрат',
		'COST.TOTAL': 'Загальна вартість',
		'COSTS': 'Витрати',
		'COST_RATE': 'Норма витрат',
		'COUNTRY': 'Країна',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Карта покриття',
		'COVERAGE.MAP.SETTINGS': 'Налаштування карти покриття',
		'COVERAGE.MAP.ZONES': 'Зони',
		'CREATED': 'Створено',
		'CREATE_USER': 'Створити користувача',
		'CROP.TYPE': 'Тип рослини',
		'CROP.NO_CROP': 'Немає культури',
		'CURRENCY': 'Валюта',
		'CUSTOMER': 'Користувач',
		'CUSTOMER.ADD': 'Додати нового користувача',
		'CUSTOMER.ADD.SUCCESS': 'Користувач успішно доданий',
		'CUSTOMER.ASSIGN': 'Призначити користувача',
		'CUSTOMER.DELETE.QUESTION': 'Ви дійсно хочете видалити дані користувача?',
		'CUSTOMER.DELETE.SUCCESS': 'Дані користувача успішно видалені',
		'CUSTOMER.DETAILS': 'Деталі користувача',
		'CUSTOMER.EDIT': 'Редагувати дані користувача',
		'CUSTOMER.EDIT.SUCCESS': 'Дані користувача успішно відредаговані',
		'CUSTOMER.NAME': 'Ім\'я користувача',
		'CUSTOMER.NO': 'Користувач відсутній',
		'CUSTOMER.NOT_SELECTED': 'Користувача не обрано',
    'CUSTOMER.NO.ASSIGNEE': 'Немає призначеного користувача',
		'CUSTOMER.SELECT': 'Вибрати користувача',
		'CUSTOMERS': 'Користувачі',
		'CUSTOMERS.ALL': 'Всі користувачі',
		'CUSTOMERS.DELETE.FAILURE': 'Дані деяких користувачів не можуть бути видалені',
		'CUSTOMERS.DELETE.QUESTION': 'Ви дійсно хочете видалити вибраних користувачів?',
		'CUSTOMERS.DELETE.SUCCESS': 'Дані користувача успішно видалені',
		'CUSTOMERS.MANAGEMENT': 'Керування користувачами',
		'CUSTOMERS.NO': 'Немає користувачів',
		'CUSTOMERS.SELECTED': 'Вибрані користувачі',
		'CUSTOM_LABELING': 'Мітки користувача',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Додати новий робочий стан',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Визначте мітку користувача для вибраного обладнання',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Визначте індивідуальні умови для мітки',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Редагування мітки користувача пройшло успішно',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Індивідуальна умова',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Дозволити перевизначення за допомогою умов ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Немає доступних міток',
		'DASHBOARD.GPS_DATA.NO': 'Немає даних GPS',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Сталася помилка під час завантаження позицій машини',
		'DATA': 'Дані',
		'DATA.ARCHIVED.WARNING': 'Основні дані частково або повністю архівуються',
		'DATA.EXPORT': 'Експорт даних',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Основні дані оновлюються',
		'DATA_PREPARATION': 'Підготовка данних',
		'DATE': 'Дата',
		'DATE.APRIL': 'Квітень',
		'DATE.AUGUST': 'Серпень',
		'DATE.DECEMBER': 'Грудень',
		'DATE.FEBRUARY': 'Лютий',
		'DATE.FRIDAY': 'П\'ятниця',
		'DATE.FROM': 'З',
		'DATE.JANUARY': 'Січень',
		'DATE.JULY': 'Липень',
		'DATE.JUNE': 'Червень',
		'DATE.MARCH': 'Березень',
		'DATE.MAY': 'Травень',
		'DATE.MONDAY': 'Понеділок',
		'DATE.NOVEMBER': 'Листопад',
		'DATE.OCTOBER': 'Жовтень',
		'DATE.PERIOD': 'Період',
		'DATE.RANGE': 'Діапазон дат',
		'DATE.SATURDAY': 'Субота',
		'DATE.SEPTEMBER': 'Вересень',
		'DATE.SUNDAY': 'Неділя',
		'DATE.THURSDAY': 'Четвер',
		'DATE.TUESDAY': 'Вівторок',
		'DATE.UNTIL': 'До',
		'DATE.WEDNESDAY': 'Середа',
		'DAY.CURRENT': 'Поточний день',
		'DAY.NEXT': 'Наступний день',
		'DAY.PREVIOUS': 'Попередній день',
		'DAY.SELECTED': 'Вибраний день',
		'DAYS': 'Дні',
		'DAY_ACTIVITIES': 'Денні активності',
		'DEACTIVATE': 'Деактивувати співробітників',
		'DEACTIVATE.SELECTED': 'Деактивувати вибране',
		'DEADLINE': 'Термін',
		'DEADLINE.ADD': 'Додати термін',
		'DEADLINE.ADD.SUCCESS': 'Термін успішно доданий',
		'DEADLINE.DELETE.SUCCESS': 'Термін успішно видалений',
		'DEADLINE.DONE': 'Закінчення',
		'DEADLINE.DUE': 'Термін виконання',
		'DEADLINE.DUE_IN_AT': 'Термін в/в',
		'DEADLINE.EDIT': 'Кінцевий термін редагування',
		'DEADLINE.EDIT.SUCCESS': 'Термін відредагований',
		'DEADLINE.IS_CLOSE': 'Даний крайній термін наближається',
		'DEADLINE.IS_OVERDUE': 'Цей термін прострочений',
		'DEADLINE.OPEN': 'Відкрити',
		'DEADLINE.PROCESS.SUCCESS': 'Дедлайн успішно дотримано',
		'DEADLINE.PROCESSED': 'Опрацьовано',
		'DEADLINE.PROCESSED.SUCCESS': 'Термін успішно оброблений',
		'DEADLINE.WARN': 'Крайній термін наближається',
		'DEADLINES': 'Терміни',
		'DEADLINES.NO': 'Немає термінів',
		'DEFINE_ROLE': 'Визначення ролі',
		'DELETE': 'Видалити',
		'DELETE.SELECTED': 'Видалити обране',
		'DELETED': 'Видалений',
		'DESCRIPTION': 'Опис',
		'DIAGRAM': 'Діаграма',
		'DISPLAY': 'Дисплей',
		'DISPLAY_TRACK': 'Показати трек',
		'DISTANCE': 'Відстань',
		'DISTANCE.TOTAL': 'Загальна відстань',
		'DISTANCE.WORKED': 'Пройдена відстань',
		'DOWNLOAD': 'Завантажити',
		'DRIVER': 'Водій',
		'DRIVER.EDIT': 'Редагування драйвера',
		'DRIVER.FIXED': 'Фіксований водій',
		'DRIVER.NO': 'Водій відсутній',
		'DRIVER.REMOVE': 'Видалити драйвер',
		'DRIVERS': 'Водії',
		'DRIVERS.ALL': 'Всі водії',
		'DRIVER_SCAN_DISABLED': 'Перевірка маячків водія неактивна',
		'DURATION': 'Тривалість',
		'DURATION.WORKED': 'Тривалість роботи',
		'EDIT': 'Редагувати',
		'EDIT.SELECTED': 'Редагувати вибрані',
		'EDIT_USER': 'Редагувати користувача',
		'EMAIL': 'Електронна пошта',
		'EMAIL.ACTIVATE': 'Активувати електронну пошту',
		'EMAIL.ACTIVATE.CODE': 'Код активації',
		'EMAIL.ACTIVATE.EXPLANATION': 'Якщо ви змінили свою адресу електронної пошти, ми відправимо код активації на вашу нову адресу.',
		'EMAIL.CHANGE': 'Змінити електронну пошту',
		'EMAIL.CHANGE.SUCCESS': 'Електронна пошта успішно змінена',
		'EMAIL.CONFIRM': 'Підтвердити електронну пошту',
		'EMAIL.CURRENT': 'Поточна електронна пошта',
		'EMAIL.INVALID': 'Електронна пошта недійсна',
		'EMAIL.NEW': 'Нова електронна пошта',
		'EMAIL.NO_MATCH': 'Адреси електронної пошти не збігаються',
		'EMPLOYEE': 'Співробітник',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Ви дійсно хочете активувати співробітника?',
		'EMPLOYEE.ADD': 'Додати співробітника',
		'EMPLOYEE.ADD.SUCCESS': 'Співробітник успішно доданий',
		'EMPLOYEE.CREATE': 'Створити співробітника',
		'EMPLOYEE.CREATE.SUCCESS': 'Співробітник успішно створений',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати співробітника?',
		'EMPLOYEE.DELETE.QUESTION': 'Ви дійсно хочете видалити співробітника?',
		'EMPLOYEE.EDIT': 'Редагувати співробітника',
		'EMPLOYEE.EDIT.SUCCESS': 'Співробітник успішно відредагований',
		'EMPLOYEE.ROLE': 'Роль співробітника',
		'EMPLOYEE.ROLE_OF': 'Роль співробітника',
		'EMPLOYEES': 'Співробітники',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Ви дійсно хочете активізувати співробітників?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Співробітники успішно активовані',
		'EMPLOYEES.ALL': 'Всі співробітники',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Деяких співробітників не вдалося деактивувати.',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати обраних співробітників?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Співробітники були деактивовані',
		'EMPLOYEES.DELETE.FAILURE': 'Деяких співробітників не вдалося видалити.',
		'EMPLOYEES.DELETE.QUESTION': 'Ви дійсно хочете видалити вибраних співробітників?',
		'EMPLOYEES.DELETE.SUCCESS': 'Співробітники видалені',
		'EMPLOYEES.MANAGEMENT': 'Керування співробітниками',
		'EMPLOYEES.NO': 'Немає співробітників',
		'EMPLOYEES.NOT_SELECTED': 'Немає обраних співробітників',
		'EMPLOYEES.SELECTED': 'Вибрані співробітники',
		'EMPLOYER.NO': 'Немає роботодавця',
		'EMPLOYER.NOT_SELECTED': 'Роботодавець не обраний',
		'EMPLOYES.NO': 'Немає співробітників',
		'END_DRAW_MODE': 'Режим малювання скасований',
		'ENTERPRISE': 'Компанія',
		'ENTERPRISE.ADD': 'Додати компанію',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Потрібно додати роботодавця',
		'ENTERPRISE.ADDED.SUCCESS': 'Підприємство успішно додано',
		'ENTERPRISE.ADD.SUCCESS': 'Успішно доданий до компанії',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Будь ласка, введіть код доступу для підприємства.',
		'ENTERPRISE.NAME': 'Назва компанії',
		'ENTERPRISE.NOT_SELECTED': 'Немає вибраної компанії',
		'ENTERPRISE.OF': 'Компанія:',
		'ENTERPRISE.SETTINGS': 'Налаштування компанії',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Конфігурацію підприємства успішно оновлено',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Машини успішно синхронізовано',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Ліцензії співробітників',
		'ENTERPRISE_LICENSE.LICENSE': 'Ліцензія',
		'ENTERPRISE_LICENSE.MACHINE': 'Ліцензія машини',
		'ENTERPRISE_LICENSE.MACHINES': 'Ліцензії машин',
		'ENTERPRISE_MIN': 'Назва компанії повинна містити не менше 3 символів.',
		'ENTERPRISE_NAME_REQUIRED': 'Потрібна назва компанії',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Додати назву компанії',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Термін дії ліцензії закінчився',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Запросити тестовий аккаунт',
		'ENTERPRISE_STATISTICS': 'Статистика підприємства',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Діаграма витрат',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Відділення процесів',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Всі',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Робота / Транспортування',
		'ENUM.ACCOUNTING_MODE.AVG': 'Середній',
		'ENUM.ACCOUNTING_MODE.MAX': 'Максимум',
		'ENUM.ACCOUNTING_MODE.MED': 'Середній',
		'ENUM.ACCOUNTING_MODE.MIN': 'Мінімум',
		'ENUM.ACCOUNTING_MODE.SUM': 'Сума',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Абсолютна різниця',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Прямий',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Негативна різниця',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Позитивна різниця',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Активний час',
		'ENUM.BEACONTYPE.BDrv': 'Водійський маячок',
		'ENUM.BEACONTYPE.BImpl': 'Маячок агрегату',
		'ENUM.CAN_IDENTIFIER.A1': 'Аналог 1',
		'ENUM.CAN_IDENTIFIER.A2': 'Аналог 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Аналог 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Аналог 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 зовнішній потік',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 втягуючий потік',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 зовнішній потік',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 втягуючий потік',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 зовнішній потік',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 втягуючий потік',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 зовнішній потік',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 втягуючий потік',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 зовнішній потік',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 втягуючий потік',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'Кут 1 середній',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'Кут 1 максимальний',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'Кут 1 мінімальний',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'Кут 2 середній',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'Кут 2 максимальний',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'Кут 2 мінімальний',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'Кут 3 середній',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'Кут 3 максимальний',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'Кут 1 мінімальний',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Застосована кислота',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Застосовані добавки',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Застосоване добриво',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Вага осі 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Вага осі 2',
		'ENUM.CAN_IDENTIFIER.C1': 'Лічильник 1',
		'ENUM.CAN_IDENTIFIER.C2': 'Лічильник 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Чоппер',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Unimog: стан блоку гідравлічного контролю 1',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Unimog: стан блоку гідравлічного контролю 2А',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Unimog: стан блоку гідравлічного контролю 2В',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Unimog: стан блоку гідравлічного контролю 3',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Unimog: стан блоку гідравлічного контролю 4',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Пробуксовка зчеплення',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Направляюча різака',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Направляюча різака (Р)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Положення різака',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Різак',
		'ENUM.CAN_IDENTIFIER.D1': 'Цифровий 1',
		'ENUM.CAN_IDENTIFIER.D2': 'Цифровий 2',
		'ENUM.CAN_IDENTIFIER.D3': 'Цифровий 3',
		'ENUM.CAN_IDENTIFIER.D4': 'Цифровий 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Важіль приводу',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Рівень AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Рівень палива',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Витрати палива',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Об/хв',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Обертаючий момент',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Переднє положення зчіпки',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'ВВП передній активний',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Швидкість переднього ВВП',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Польовий перемикач',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Польовий перемикач2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Тяга спереду',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Тяга (номінальна) спереду',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Напрямок (наземний)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Швидкість на землі',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Швидкість GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Обрана передача',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Положення зернового конвеєра',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Рівень зернового бункера',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'Unimog: напрямок руху',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'Unimog: стан гидростату',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Впровадити робочий стан',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Робота активна',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Швидкість двигуна (ліворуч)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Крутний момент двигуна (ліворуч)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Швидкість двигуна (праворуч)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Крутний момент двигуна (праворуч)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'Немає значення',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE абсолютний',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE родич',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'Добриво pH',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Перемикач ВВП',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Перемикач ВВП1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'Перемикач ВВП2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'PTO_Switch3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Датчик наближення',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Заднє положення зчіпки',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'Задній ВВП активний',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Швидкість заднього ВОМ',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Тяга ззаду',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Тяга (номінальна) ззаду',
		'ENUM.CAN_IDENTIFIER.Roll': 'Швидкість обертання',
		'ENUM.CAN_IDENTIFIER.Sli': 'Прослизання',
		'ENUM.CAN_IDENTIFIER.Spe': 'Швидкість',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Положення соломорізки',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Молотильний барабан',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Тиск в лівій шині A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Тиск в шинах зліва A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Тиск в шинах праворуч A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Тиск в шинах праворуч A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'Стан розвантажувального шнека',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Напрямок (на основі колеса)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Швидкість на основі колеса',
		'ENUM.CAN_IDENTIFIER.Xacc': 'Прискорення X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'Прискорення Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'Відхилення від курсу',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Фактична врожайність',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Вологість врожаю',
		'ENUM.CAN_IDENTIFIER.Zacc': 'Прискорення Z',
		'ENUM.COSTPER.h': 'г',
		'ENUM.COSTPER.ha': 'га',
		'ENUM.COSTPER.km': 'км',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': '£',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Адміністратор',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Консультант',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Диспетчер',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Водій',
		'ENUM.EVENTTYPE.COMMENT': 'Повідомлення',
		'ENUM.EVENTTYPE.CT': 'Лічильник',
		'ENUM.EVENTTYPE.CT_RS': 'Скидання лічильника',
		'ENUM.EVENTTYPE.CUSTOMER': 'Користувач',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Співробітник підключається до обладнання',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Співробітник в\'їжджає на поле',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Співробітник заходить в трактор',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Співробітник залишає поле',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Співробітник залишає трактор',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Співробітник починає перерву',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Співробітник закінчує перерву',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Співробітник роз\'єднує обладнання',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Співробітник починає роботу',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Співробітник закінчує роботу',
		'ENUM.EVENTTYPE.GTO70': 'Зерновий бункер заповнений',
		'ENUM.EVENTTYPE.JOBINFO': 'Інформація про роботу',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Перерва в роботі',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Продовження роботи',
		'ENUM.EVENTTYPE.JOB_START': 'Початок роботи',
		'ENUM.EVENTTYPE.JOB_STOP': 'Закінчення роботи',
		'ENUM.EVENTTYPE.L_IMPL': 'Обладнання завантажено',
		'ENUM.EVENTTYPE.REFUELING': 'Заправка',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'Клієнт SyreN',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'Поле SyreN',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Тип суспензії SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter онлайн',
		'ENUM.EVENTTYPE.UL_IMPL': 'Обладнання розвантажено',
		'ENUM.EVENTTYPE.WEATHER': 'Погода',
		'ENUM.EVENTTYPE.WEIGHING': 'Зважування',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Зважування (Тара)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Створено',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'На машині',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Готово',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Заархівовано',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Видалення',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Редагування',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Генерування',
		'ENUM.JOBGENERATIONSTATE.MER': 'Злиття',
		'ENUM.JOBGENERATIONSTATE.QUE': 'В черзі',
		'ENUM.JOBGENERATIONSTATE.READY': 'ОК',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Відновлення',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Розділення',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Оновлення',
		'ENUM.LOCATIONTYPE.FARM': 'Ферма',
		'ENUM.LOCATIONTYPE.FUEL': 'Заправна станція',
		'ENUM.LOCATIONTYPE.OTHERS': 'Інші',
		'ENUM.LOCATIONTYPE.STABLE': 'Конюшня',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Вагова',
		'ENUM.MACHINETYPE.COMBINE': 'Комбайн',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Екскаватор',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Кормозбиральний комбайн',
		'ENUM.MACHINETYPE.MISC': 'Інші',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Самохідний',
		'ENUM.MACHINETYPE.SYREN': 'Syren',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Телескопічний навантажувач',
		'ENUM.MACHINETYPE.TRACTOR': 'Трактор',
		'ENUM.MACHINETYPE.TRUCK': 'Вантажівка',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Фронтальний вантажник',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Вісі',
		'ENUM.MSGUNIT.CUBIC_M': 'м3',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'кг',
		'ENUM.MSGUNIT.LITER': 'л',
		'ENUM.MSGUNIT.TONS': 'т',
		'ENUM.MSGUNIT.h': 'г',
		'ENUM.MSGUNIT.ha': 'га',
		'ENUM.MSGUNIT.km': 'км',
		'ENUM.ONLY_ON_STATE.A': 'Завжди',
		'ENUM.ONLY_ON_STATE.F': 'Поле',
		'ENUM.ONLY_ON_STATE.L': 'Місцезнаходження',
		'ENUM.ONLY_ON_STATE.R': 'Дорога',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Тип 1 (записує на USB-накопичувач)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Тип 2 (не записує на флешку)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Вісі',
		'ENUM.TRANSPORTUNIT.BALE': 'Тюк',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'м3',
		'ENUM.TRANSPORTUNIT.KG': 'кг',
		'ENUM.TRANSPORTUNIT.LITER': 'л',
		'ENUM.TRANSPORTUNIT.TONS': 'т',
		'ENUM.USERROLE.ADMIN': 'Адміністратор',
		'ENUM.USERROLE.ENTERPRISE': 'Компанія',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Техніка. Продажна сила',
		'ENUM.USERROLE.TRAN': 'Переклад',
		'ENUM.USERROLE.USER': 'Користувач',
		'ENUM.USERROLE.USER_EMPL': 'Користувач (Підприємство)',
		'ENUM.USERSTATE.ACTIVE': 'Активно',
		'ENUM.USERSTATE.DISABLED': 'Не активно',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Не підтверджено',
		'ENUM.WORKSTATE.DRIVING': 'В дорозі',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Очікування водіння',
		'ENUM.WORKSTATE.MISC_FIELD': 'Очікування поля',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Зерновий бункер заповнений',
		'ENUM.WORKSTATE.MISC_ROAD': 'Очікування дороги',
		'ENUM.WORKSTATE.PAUSE': 'Пауза',
		'ENUM.WORKSTATE.PREPARATION': 'Підготовка',
		'ENUM.WORKSTATE.ROAD': 'Дорога',
		'ENUM.WORKSTATE.THRESHING': 'Молотьба',
		'ENUM.WORKSTATE.THRESHING_U': 'Розвантаження при обмолоті',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Молотьба з подрібнювачем соломи',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Розвантаження при обмолоті за допомогою подрібнювача соломи',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Завантажено',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Очікування завантаження',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Завантаження',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Розвантажено',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Очікування розвантаження',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Розвантаження',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Молотьба під час розвантаження',
		'ENUM.WORKSTATE.TURNING': 'Поворот',
		'ENUM.WORKSTATE.UNDEFINED': 'Не визначено',
		'ENUM.WORKSTATE.WORKING': 'Робота',
		'ENUM.WORKSTATE.WORKING_MISC': 'Очікування роботи',
		'ERROR.NO_GPS_DATA': 'Немає даних gps для обраної машини.',
		'ERROR_MESSAGE': 'Повідомлення про помилку',
		'EVENTS': 'Події',
		'EVENTS.FIELD': 'Події на полі',
		'EVENTS.NO': 'Немає подій',
		'EXA_ADAPTERS': 'Адаптер',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Активувати адаптер в Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Видалити адаптер в Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Адаптер активований в Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Адаптер видалений з Agrirouter',
		'EXCEPTION.1': 'Внутрішня помилка',
		'EXCEPTION.100': 'Недопустиме значення',
		'EXCEPTION.1000': 'Ім\'я користувача не заповнено',
		'EXCEPTION.10000': 'Назву файлу не заповнено',
		'EXCEPTION.10001': 'Дані незаповнені',
		'EXCEPTION.10002': 'Тип формату недійсний',
		'EXCEPTION.10003': 'Тип запиту даних недійсний',
		'EXCEPTION.10004': 'Немає вихідних даних',
		'EXCEPTION.1001': 'Довжина імені користувача менше мінімальної довжини',
		'EXCEPTION.1002': 'Таке ім\'я вже існує',
		'EXCEPTION.1003': 'Адреса електронної пошти недійсна',
		'EXCEPTION.1004': 'Така адреса електронної пошти вже існує',
		'EXCEPTION.1005': 'Довжина пароля менше мінімальної',
		'EXCEPTION.1007': 'Код підтвердження недійсний',
		'EXCEPTION.1008': 'Ім\'я користувача (або адреса електронної пошти) є недійсною',
		'EXCEPTION.101': 'Недійсна роль співробітника',
		'EXCEPTION.1011': 'Користувач не існує',
		'EXCEPTION.1012': 'Користувача видалено',
		'EXCEPTION.1013': 'Користувач неактивний',
		'EXCEPTION.1014': 'Користувач заблокований',
		'EXCEPTION.1015': 'Користувач не активований',
		'EXCEPTION.1016': 'Користувач - корпоративний обліковий запис',
		'EXCEPTION.102': 'Валюта недійсна',
		'EXCEPTION.1020': 'Такий користувач вже існує',
		'EXCEPTION.1021': 'Така електронна адреса вже існує',
		'EXCEPTION.1022': 'Адреса електронної пошти не змінилася',
		'EXCEPTION.1023': 'Поточний пароль не збігається',
		'EXCEPTION.1024': 'Таке ім\'я користувача вже існує',
		'EXCEPTION.1025': 'Користувач і код не збігаються',
		'EXCEPTION.1026': 'Ім\'я користувача (або адреса електронної пошти) є недійсним',
		'EXCEPTION.1027': 'Користувач вже активований',
		'EXCEPTION.1028': 'Заборонено для облікових записів співробітників, створених для компанії',
		'EXCEPTION.103': 'Транспортна одиниця недійсна',
		'EXCEPTION.104': 'Неприпустимий тип розташування',
		'EXCEPTION.105': 'Неприпустима одиниця вартості',
		'EXCEPTION.106': 'Недійсна одиниця',
		'EXCEPTION.107': 'Неприпустимий тип машини',
		'EXCEPTION.108': 'Статус співробітника недійсний',
		'EXCEPTION.11000': 'Тип недійсний',
		'EXCEPTION.12000': 'Тип недійсний',
		'EXCEPTION.12002': 'Серійний номер не заповнений',
		'EXCEPTION.12003': 'Стан роботи недійсний',
		'EXCEPTION.12004': 'Стан роботи недійсний',
		'EXCEPTION.12006': 'Немає конфігурації T2',
		'EXCEPTION.12007': 'MAC порожній',
		'EXCEPTION.12008': 'MAC недійсний',
		'EXCEPTION.12009': 'Адаптер вже існує',
		'EXCEPTION.12010': 'Неприпустимий тип адаптера',
		'EXCEPTION.15000': 'Час початку порожній або знаходиться в майбутньому',
		'EXCEPTION.15001': 'Час зупинки порожній або знаходиться в майбутньому',
		'EXCEPTION.15002': 'Час зупинки дорівнює або раніше початку',
		'EXCEPTION.15003': 'Неможливо згенерувати пакет SILO - немає вихідних даних',
		'EXCEPTION.15004': 'Вихідні дані застаріли',
		'EXCEPTION.16000': 'Ім\'я не заповнено',
		'EXCEPTION.16001': 'Призначений клієнт не існує',
		'EXCEPTION.16002': 'Список маркерів порожній',
		'EXCEPTION.16003': 'У списку маркерів має бути не менше трьох маркерів.',
		'EXCEPTION.16004': 'Площа не заповнена',
		'EXCEPTION.16005': 'Тип маркера недійсний',
		'EXCEPTION.16006': 'Поле не міститься в завданні',
		'EXCEPTION.16007': 'Розмір сітки більше половини висоти і ширини поля',
		'EXCEPTION.16008': 'Немає даних для введення',
		'EXCEPTION.16009': 'Всі дані містять одне і те ж значення',
		'EXCEPTION.17000': 'Ім\'я не заповнено',
		'EXCEPTION.17001': 'Контактну особу не заповнено',
		'EXCEPTION.17002': 'Номер телефону не заповнений',
		'EXCEPTION.17003': 'Адресу електронної пошти не заповнено',
		'EXCEPTION.17004': 'Адреса електронної пошти недійсна',
		'EXCEPTION.17005': 'Адреса не заповнена',
		'EXCEPTION.17006': 'Поштовий код не заповнений',
		'EXCEPTION.17007': 'Місто не заповнено',
		'EXCEPTION.17008': 'Невірний колір ((AA) RRGGBB)',
		'EXCEPTION.18000': 'Тип недійсний',
		'EXCEPTION.19001': 'Тип недійсний',
		'EXCEPTION.19002': 'MAC порожній',
		'EXCEPTION.19003': 'MAC недійсний',
		'EXCEPTION.19004': 'Потужність менше нуля',
		'EXCEPTION.19007': 'Співробітник не заповнений',
		'EXCEPTION.19008': 'Маячок не для навісного обладнання',
		'EXCEPTION.19009': 'Маячок не для водія',
		'EXCEPTION.2': 'Повторюваний запис',
		'EXCEPTION.200': 'Помилка аналізу типу об\'єкта Json',
		'EXCEPTION.2000': 'Не вдалося створити код підтвердження.',
		'EXCEPTION.20000': 'Вихідний обсяг даних недостатній',
		'EXCEPTION.20001': 'Помилка створення архівного файлу',
		'EXCEPTION.20002': 'Помилка завантаження файлу архіву',
		'EXCEPTION.2001': 'Код підтвердження не існує',
		'EXCEPTION.2002': 'Код підтвердження недійсний',
		'EXCEPTION.201': 'Не вдалося записати об\'єкт в Json',
		'EXCEPTION.21000': 'Ім\'я компанії не заповнено',
		'EXCEPTION.21001': 'Компанія з таким ім\'ям вже існує',
		'EXCEPTION.21002': 'Довжина назви підприємства менше мінімальної',
		'EXCEPTION.21003': 'Корпоративна адреса електронної пошти недійсна',
		'EXCEPTION.21004': 'Токен доступу вже існує',
		'EXCEPTION.21005': 'Компанія видалена',
		'EXCEPTION.21006': 'Компанію деактивовано',
		'EXCEPTION.21007': 'Компанія заблокована',
		'EXCEPTION.21008': 'Неприпустимий тип компанії',
		'EXCEPTION.22000': 'Немає робіт для додавання',
		'EXCEPTION.22001': 'Робота не змінена',
		'EXCEPTION.23000': 'Компанія не зареєстрована',
		'EXCEPTION.23001': 'Компанія вже зареєстрована',
		'EXCEPTION.23002': 'Адаптер не зареєстрований',
		'EXCEPTION.23003': 'Адаптер вже зареєстрований',
		'EXCEPTION.23004': 'Не вдалося зареєструвати адаптер',
		'EXCEPTION.23005': 'Не вдалося перевстановити адаптер',
		'EXCEPTION.23006': 'Не вдалося вимкнути адаптер',
		'EXCEPTION.23007': 'Не вдалося опублікувати можливості vCU',
		'EXCEPTION.23008': 'Не вдалося опублікувати дані vCU.',
		'EXCEPTION.23009': 'Не вдалося опублікувати опис пристрою vCU.',
		'EXCEPTION.23010': 'Не вдалося опублікувати можливості компанії',
		'EXCEPTION.23011': 'Помилка сертифіката Agrirouter! Ви оновили підключення до Agrirouter?',
		'EXCEPTION.24000': 'Ім\'я компанії не заповнено',
		'EXCEPTION.24001': 'Таку назва вже існує',
		'EXCEPTION.24002': 'Довжина назви компанії менше мінімальної',
		'EXCEPTION.24003': 'Корпоративна адреса електронної пошти недійсна',
		'EXCEPTION.24004': 'Токен доступу вже існує',
		'EXCEPTION.24005': 'Компанія видалена',
		'EXCEPTION.24006': 'Компанія деактивована',
		'EXCEPTION.24007': 'Компанія заблокована',
		'EXCEPTION.25000': 'Функція недоступна для обраного партнера',
		'EXCEPTION.25001': 'Помилка синхронізації полів',
		'EXCEPTION.25002': 'Помилка синхронізації машин',
		'EXCEPTION.25003': 'Помилка синхронізації обладнання',
		'EXCEPTION.25004': 'Помилка отримання машини',
		'EXCEPTION.25005': 'Помилка створення машини',
		'EXCEPTION.25006': 'Помилка оновлення машини',
		'EXCEPTION.25007': 'Помилка видалення машини',
		'EXCEPTION.25008': 'Помилка отримання обладнання',
		'EXCEPTION.25009': 'Помилка створення обладнання',
		'EXCEPTION.25010': 'Помилка оновлення обладнання',
		'EXCEPTION.25011': 'Помилка видалення обладнання',
		'EXCEPTION.26000': 'Помилка створення PDF-файлу',
		'EXCEPTION.26001': 'Обране завдання не є завданням з підтримкою SyreN.',
		'EXCEPTION.27000': 'Машина не підтримує файли TaskData',
		'EXCEPTION.27001': 'Помилка створення файлу TaskData',
		'EXCEPTION.27002': 'Помилка завантаження файлу TaskData',
		'EXCEPTION.27003': 'У машини немає призначеного адаптера',
		'EXCEPTION.27004': 'Ім\'я не заповнено',
		'EXCEPTION.27005': 'Планована дата порожня',
		'EXCEPTION.27006': 'Запланована дата не в майбутньому',
		'EXCEPTION.27007': 'Стан відсутній',
		'EXCEPTION.27008': 'Файл порожній',
		'EXCEPTION.27009': 'Файл не заповнено',
		'EXCEPTION.27010': 'Дата не заповнена',
		'EXCEPTION.27011': 'Дата не в майбутньому',
		'EXCEPTION.27012': 'Розмір менше одиниці',
		'EXCEPTION.27013': 'Операція TaskData недоступна в поточному стані',
		'EXCEPTION.27014': 'Файл з такою назвою вже існує',
		'EXCEPTION.27015': 'Немає відкритих завдань',
		'EXCEPTION.27016': 'Дозволено тільки один незавантажений файл TaskData',
		'EXCEPTION.28001': 'Тип файлу не підтримується',
		'EXCEPTION.29000': 'Оновлення заборонено (вже оброблено)',
		'EXCEPTION.29001': 'Немає машини або обладнання',
		'EXCEPTION.29002': 'Допускається тільки машина або агрегат',
		'EXCEPTION.29003': 'Базове значення має бути більше нуля',
		'EXCEPTION.29004': 'Значення попередження має бути більше нуля',
		'EXCEPTION.29005': 'Належна вартість повинна бути більше нуля',
		'EXCEPTION.29006': 'Належний інтервал повинен бути більше, ніж інтервал попередження.',
		'EXCEPTION.3000': 'Інформація для входу недійсна',
		'EXCEPTION.3001': 'Аккаунт заблокований',
		'EXCEPTION.3002': 'Аккаунт не активований',
		'EXCEPTION.3003': 'Термін дії сеансу минув - будь ласка, увійдіть знову',
		'EXCEPTION.3004': 'Інший користувач увійшов в систему з цим же обліковим записом',
		'EXCEPTION.31000': 'Додаток не підтримується',
		'EXCEPTION.4000': 'Пусто',
		'EXCEPTION.4001': 'Модель не заповнена',
		'EXCEPTION.4002': 'Рік повинен бути більше 1950 і не в майбутньому.',
		'EXCEPTION.4003': 'Вартість менше або дорівнює нулю',
		'EXCEPTION.4004': 'Години роботи менше нуля',
		'EXCEPTION.4005': 'Пробіг менше нуля',
		'EXCEPTION.4007': 'Робоча ширина менше нуля',
		'EXCEPTION.4008': 'Невірний колір ((AA) RRGGBB)',
		'EXCEPTION.4009': 'Конфігурація недійсна',
		'EXCEPTION.401': 'Не авторизовано',
		'EXCEPTION.4010': 'Забагато строк конфігурації',
		'EXCEPTION.4011': 'Неприпустима динамічна конфігурація',
		'EXCEPTION.4012': 'Тип машини не трактор',
		'EXCEPTION.4013': 'Використовується максимальна кількість ліцензій TC',
		'EXCEPTION.4014': 'Дата в майбутньому',
		'EXCEPTION.4015': 'Неприпустима зміна швидкості',
		'EXCEPTION.403': 'Заборонено',
		'EXCEPTION.450': 'Помилка команди',
		'EXCEPTION.451': 'Ліцензія не потрібна',
		'EXCEPTION.452': 'Неприпустимий параметр фільтра',
		'EXCEPTION.5000': 'Пусто',
		'EXCEPTION.5001': 'Пусто',
		'EXCEPTION.5002': 'Рік повинен бути більше 1950 і не в майбутньому',
		'EXCEPTION.5003': 'Тип 1 не заповнений',
		'EXCEPTION.5004': 'Тип 2 недійсний',
		'EXCEPTION.5005': 'Вартість менше або дорівнює нулю',
		'EXCEPTION.5006': 'Робоча ширина менше нуля',
		'EXCEPTION.5007': 'Транспортне значення менше нуля',
		'EXCEPTION.5008': 'Транспортна одиниця недійсна',
		'EXCEPTION.5009': 'Тип 3 недійсний',
		'EXCEPTION.5010': 'Неприпустима комбінація типів',
		'EXCEPTION.5011': 'Ідентифікатор обліку недійсний',
		'EXCEPTION.6000': 'Тип недійсний',
		'EXCEPTION.6001': 'Радіус порожній або менше нуля',
		'EXCEPTION.6002': 'Ім\'я не заповнено',
		'EXCEPTION.6003': 'Список маркерів порожній',
		'EXCEPTION.6004': 'У списку маркерів має бути не менше трьох маркерів',
		'EXCEPTION.6005': 'Тип маркера недійсний',
		'EXCEPTION.6006': 'Тип зважування недійсний',
		'EXCEPTION.700': 'Недійсно',
		'EXCEPTION.7001': 'Аккаунт не існує',
		'EXCEPTION.7002': 'Аккаунт заблокований',
		'EXCEPTION.701': 'Формула недійсна',
		'EXCEPTION.702': 'Недійсно',
		'EXCEPTION.703': 'Умова недійсна',
		'EXCEPTION.704': 'Недійсно',
		'EXCEPTION.705': 'Неприпустимий параметр робочого стану',
		'EXCEPTION.706': 'Неприпустимий робочий стан для типу агрегату',
		'EXCEPTION.707': 'Помилка створення файлу',
		'EXCEPTION.800': 'Ім\'я значення конфігурації недійсне',
		'EXCEPTION.8000': 'Роботодавець порожній',
		'EXCEPTION.8001': 'Співробітник порожній',
		'EXCEPTION.8002': 'Співробітник не найден для роботодавця',
		'EXCEPTION.8003': 'Вартість менше нуля',
		'EXCEPTION.8004': 'Максимальна кількість використаних ліцензій',
		'EXCEPTION.8005': 'Не є вашим співробітником',
		'EXCEPTION.8006': 'Співробітник вже існує',
		'EXCEPTION.8007': 'Токен доступу порожній',
		'EXCEPTION.8008': 'Токен доступу недійсний',
		'EXCEPTION.8009': 'У компанії повинен бути хоча б один адміністратор',
		'EXCEPTION.8010': 'Користувач може бути підключений тільки до того підприємства, яке його створило.',
		'EXCEPTION.900': 'Не існує',
		'EXCEPTION.9000': 'Час початку порожній або в майбутньому',
		'EXCEPTION.9001': 'Час зупинки порожній або в майбутньому',
		'EXCEPTION.9002': 'Час зупинки дорівнює або менше часу початку',
		'EXCEPTION.9003': 'Водій не є співробітником власника роботи',
		'EXCEPTION.9004': 'Обладнання не належить власнику роботи',
		'EXCEPTION.9005': 'Тип 1 недійсний',
		'EXCEPTION.9006': 'Тип 2 недійсний',
		'EXCEPTION.9007': 'Тип 3 недійсний',
		'EXCEPTION.9008': 'Неможливо створити завдання - немає вихідних даних',
		'EXCEPTION.9009': 'Власник машини не збігається з власником обладнання',
		'EXCEPTION.901': 'Вже існує',
		'EXCEPTION.9010': 'Робота вже існує',
		'EXCEPTION.9012': 'Робота не готова',
		'EXCEPTION.9013': 'Робота відмічена для видалення',
		'EXCEPTION.9014': 'Робота заархівована - немає доступних робіт',
		'EXCEPTION.9015': 'Вихідні дані застаріли',
		'EXCEPTION.9016': 'Як мінімум одна робота є частиною завдання',
		'EXCEPTION.9017': 'Завдання не збігаються (машина, водій, навісне устаткування повинні збігатися)',
		'EXCEPTION.9018': 'Розрив між роботами занадто великий',
		'EXCEPTION.9019': 'Як мінімум одна робота є частиною завдання',
		'EXCEPTION.902': 'Власник не існує',
		'EXCEPTION.9020': 'Без поділу часу',
		'EXCEPTION.9021': 'Час поділу не більш часу початку і менше часу зупинки',
		'EXCEPTION.9022': 'Немає ідентифікаторів робіт для злиття',
		'EXCEPTION.9023': 'Потрібно як мінімум дві роботи',
		'EXCEPTION.9024': 'Щільність точок повинна бути більше нуля і менше або дорівнювати одиниці',
		'EXCEPTION.903': 'Об\'єкт з ідентифікатором не існує',
		'EXCEPTION.904': 'Широта поза діапазону',
		'EXCEPTION.905': 'Довгота поза допустимого діапазону',
		'EXCEPTION.906': 'Власник не відповідає',
		'EXCEPTION.907': 'Параметр порожній',
		'EXCEPTION.99': 'Параметр недійсний',
		'EXPORT': 'Експорт',
		'EXPORT.FILTERED_JOBS': 'Експорт всіх відфільтрованих робіт',
		'EXPORT.JOB_DETAILS': 'Експорт відомостей про роботу',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Експортуйте всі дані по клієнту за вибраний період',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Експорт всіх операцій з полями за обраний період',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Експорт всіх операцій на локаціях за обраний період',
		'EXPORT.POINTS': 'Точка даних',
		'EXPORT.POLYGONS': 'Багатокутники',
		'EXPORT.RAW_DATA_AS_SILO': 'Експорт у вигляді файлу SILO',
		'EXPORT.SELECTED': 'Експорт обраних',
		'EXPORT.SELECT_DATA': 'Виберіть дані, які будуть включені в звіт в форматі PDF',
		'EXPORT.SELECT_PERIOD': 'Виберіть період для експорту:',
		'FIELD': 'Поле',
		'FIELD.ADD': 'Додати поле',
		'FIELD.ADD.SUCCESS': 'Поле успішно додано',
		'FIELD.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати поле?',
		'FIELD.DEACTIVATE.SUCCESS': 'Поле успішно деактивовано',
		'FIELD.DELETE.QUESTION': 'Ви дійсно хочете видалити поле?',
		'FIELD.DELETE.SUCCESS': 'Поле успішно видалено',
		'FIELD.DETAILS': 'Деталі поля',
		'FIELD.DRAW.START': 'Намалювати кордони поля на карті!',
		'FIELD.EDIT.SUCCESS': 'Поле успішно змінено',
		'FIELD.INTERPOLATE': 'Вводити',
		'FIELD.INTERPOLATED_VALUES': 'Введені значення',
		'FIELD.INTERPOLATION': 'Введення',
		'FIELD.INTERPOLATION_SETTINGS': 'Налаштування введення',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Відмінно',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Дуже добре',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Грубий',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Стандартний',
		'FIELD.NUMBER': 'Номер поля',
		'FIELD.PROCESSED': 'Оброблене поле',
		'FIELDS': 'Поля',
		'FIELDS.ALL': 'Всі поля',
		'FIELDS.DEACTIVATE.FAILURE': 'Деякі з полів не вдалося деактивувати.',
		'FIELDS.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати поля?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Поля успішно деактивовано',
		'FIELDS.DELETE.FAILURE': 'Не вдалося видалити деякі поля',
		'FIELDS.DELETE.QUESTION': 'Ви дійсно хочете видалити вибрані поля?',
		'FIELDS.DELETE.SUCCESS': 'Поля успішно видалені',
		'FIELDS.EDIT': 'Редагувати поля',
		'FIELDS.IMPORT': 'Імпорт полів',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Ви хочете призначити клієнта до обраних полів?',
		'FIELDS.IMPORT.SHAPE': 'Будь ласка, виберіть формат SHAPE для імпорту',
		'FIELDS.IMPORT.SUCCESS': 'Поля успішно імпортовано',
		'FIELDS.MANAGEMENT': 'Управління полями',
		'FIELDS.NO': 'Немає полів',
		'FIELDS.NOT_SELECTED': 'Немає обраних полів',
		'FIELDS.REACTIVATE.FAILURE': 'Деякі з полів не вдалося відновити.',
		'FIELDS.REACTIVATE.QUESTION': 'Ви дійсно хочете повторно активувати вибрані поля?',
		'FIELDS.REACTIVATE.SUCCESS': 'Успішне відновлення роботи полів',
		'FIELDS.SELECT': 'Виберіть поля',
		'FIELDS.SELECTED': 'Вибрані поля',
		'FILE': 'Файл',
		'FILE.GENERATING': 'Файл буде створено та додано до файлового менеджера найближчим часом',
		'FILE.GENERATING.READY': 'Новий файл готовий до завантаження',
		'FILE.MANAGER': 'Файловий менеджер',
		'FILE.NO_FILES': 'Немає існуючих файлів',
		'FILE.UPLOAD': 'Завантажити файл',
		'FILE_TRANSFER': 'Управління ISOTaskData',
		'FILE_TRANSFER.ADD': 'Додати ISOTaskData',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData успішно доданий',
		'FILE_TRANSFER.CREATE': 'Додати ISOTaskData',
		'FILE_TRANSFER.DELETE.QUESTION': 'Ви дійсно хочете видалити ISOTaskData?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData успішно видалений',
		'FILE_TRANSFER.FINISHED_TASKS': 'Готові завдання',
		'FILE_TRANSFER.NO': 'Немає ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Завдання в черзі',
		'FILTER': 'Фільтр',
		'FIRMWARE_VERSION': 'Версія прошивки',
		'FIRSTNAME': 'Ім\'я',
		'FORMS.FILE_TOO_LARGE': 'Файл занадто великий',
		'FORMS.NO_PASSWORD_MATCH': 'Паролі не відповідають!',
		'FORMS.REQUIRED': 'Обов\'язково',
    'FORMS.INVALID_EMAIL': 'Неправильна адреса електронної пошти',
		'FORMULA': 'Формула',
		'FUEL': 'Паливо',
		'FUEL.CONSUMPTION': 'Витрати палива',
		'FUEL.CONSUMPTION.AREA': 'Витрата палива на площу',
		'FUEL.CONSUMPTION.AVERAGE': 'Середня витрата палива',
		'FUEL.CONSUMPTION.OVERALL': 'Загальна витрата пального',
		'FUEL.CONSUMPTION.TOTAL': 'Загальні витрата палива',
		'FUEL.COST': 'Вартість палива',
		'FUEL.LEVEL': 'Рівень палива',
		'FUEL.PRICE_PER_LITER': 'Вартість палива за літр',
		'FUEL.WARNING': 'Низький рівень палива!',
		'GENERAL_INSPECTION': 'Загальний огляд',
		'GEOMETRIES.UPDATE': 'Оновлення полів та локацій',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Для коректного призначення після додавання нової геометрії необхідно оновити всі базові дані. Ви хочете оновити дані зараз?',
		'GEOMETRY.CLICK_TO_SAVE': 'Щоб зберегти, клацніть на карта.',
		'GPS': 'GPS',
		'GPS.GPS': 'Внутрішний GPS',
		'GPS.LP': 'Остання відома позиція',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (висока точність)',
		'GPS.STATUS': 'GPS статус',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'GPS для визначення відстані до місця зчеплення',
		'HARDWARE': 'Апаратне забезпечення',
		'HARDWARE.SETUP.PRINT_STICKER': 'Друк наклейки на обладнання',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Роздрукуйте наклейку на упаковку',
		'HARDWARE.SETUP.RESET_DEVICE': 'Скидання пристрою',
		'HARDWARE.SETUP.SET_SERIAL': 'Серійний номер',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Модель відповідно до введення',
		'HINT_MARKERS.SHOW': 'Показати маркери підказок',
		'HITCH_TO_APPLICATION_DISTANCE': 'Відстань до місця внесення добрива',
		'HOME': 'Ласкаво просимо',
		'HOME.CONTACTREPLY1': 'Будемо раді Вашому дзвінку',
		'HOME.CONTACTREPLY2': 'або надішліть нам лист на електронну пошту',
		'HOME.INTRODUCTORY_VIDEOS': 'Вступні відео',
		'HOME.NEWSINFO1': 'Всі новини та інформацію про управління автопарком і відстеження машин можна знайти на нашому',
		'HOME.NEWSINFO2': 'або на нашому',
		'HOME.PROFILEEXPLANATION': 'У розділі «Мій профіль» ви можете змінити свої особисті дані, адресу електронної пошти та пароль.',
		'HOME.QUESTIONSYSTEM': 'У вас є питання про нашу систему?',
		'HOME.TITLE': 'Ласкаво просимо',
		'HOME.WELCOMEAREA': 'Ласкаво просимо на вашу площу!',
		'IDLE': 'Холостий',
		'IGNORE': 'Ігнорувати.',
		'IMPLEMENT': 'Обладнання',
		'IMPLEMENT.ADD': 'Додати обладнання',
		'IMPLEMENT.ADD.SUCCESS': 'Обладнання успішно додано',
		'IMPLEMENT.CLASS': 'Клас обладнання',
		'IMPLEMENT.DELETE.QUESTION': 'Ви дійсно хочете видалити обладнання?',
		'IMPLEMENT.DELETE.SUCCESS': 'Обладнання успішно видалено',
		'IMPLEMENT.DETAILS': 'Деталі обладнання',
		'IMPLEMENT.EDIT': 'Редагувати обладнання',
		'IMPLEMENT.EDIT.SUCCESS': 'Обладнання успішно відредаговано',
		'IMPLEMENT.FIXED': 'Зафіксоване обладнання',
		'IMPLEMENT.NO': 'Немає обладнання',
		'IMPLEMENT.PROCESS.0': 'Робота без обладнання',
		'IMPLEMENT.PROCESS.1': 'Пакетування круглих тюків',
		'IMPLEMENT.PROCESS.10': 'Прокатка',
		'IMPLEMENT.PROCESS.11': 'Посів',
		'IMPLEMENT.PROCESS.12': 'Посадка',
		'IMPLEMENT.PROCESS.13': 'Внесення добрив',
		'IMPLEMENT.PROCESS.14': 'Обприскування',
		'IMPLEMENT.PROCESS.15': 'Зрошення',
		'IMPLEMENT.PROCESS.16': 'Покос',
		'IMPLEMENT.PROCESS.17': 'Збір',
		'IMPLEMENT.PROCESS.18': 'Транспортування',
		'IMPLEMENT.PROCESS.19': 'Збирання',
		'IMPLEMENT.PROCESS.2': 'Пакетування квадратних тюків',
		'IMPLEMENT.PROCESS.20': 'Прибирання і вивезення снігу',
		'IMPLEMENT.PROCESS.21': 'Розповсюдження солі',
		'IMPLEMENT.PROCESS.22': 'Рихлення',
		'IMPLEMENT.PROCESS.23': 'Внесення добрив',
		'IMPLEMENT.PROCESS.24': 'Перекачування рідкого навоза',
		'IMPLEMENT.PROCESS.25': 'Змішування навоза',
		'IMPLEMENT.PROCESS.26': 'Посадка картоплі',
		'IMPLEMENT.PROCESS.27': 'Збирання картоплі',
		'IMPLEMENT.PROCESS.28': 'Розділення',
		'IMPLEMENT.PROCESS.29': 'Формування гребеня',
		'IMPLEMENT.PROCESS.3': 'Упаковка для тюків',
		'IMPLEMENT.PROCESS.30': 'Верхня частина бадилля',
		'IMPLEMENT.PROCESS.31': 'Валкування',
		'IMPLEMENT.PROCESS.32': 'Боронування',
		'IMPLEMENT.PROCESS.33': 'Боронування',
		'IMPLEMENT.PROCESS.34': 'Подрібнення',
		'IMPLEMENT.PROCESS.35': 'Збирання',
		'IMPLEMENT.PROCESS.36': 'Заметіль',
		'IMPLEMENT.PROCESS.37': 'Переміщення контейнерів для рідкого навоза',
		'IMPLEMENT.PROCESS.38': 'Формування грядки',
		'IMPLEMENT.PROCESS.39': 'Підживлення',
		'IMPLEMENT.PROCESS.4': 'упаковка тюків',
		'IMPLEMENT.PROCESS.40': 'Переміщення деревини',
		'IMPLEMENT.PROCESS.41': 'Пиляння деревини',
		'IMPLEMENT.PROCESS.42': 'Розпил деревини',
		'IMPLEMENT.PROCESS.43': 'Фрезерування пнів',
		'IMPLEMENT.PROCESS.44': 'Завантаження сипучих матеріалів',
		'IMPLEMENT.PROCESS.45': 'Завантаження піддонів',
		'IMPLEMENT.PROCESS.46': 'Завантаження тюків',
		'IMPLEMENT.PROCESS.47': 'CCM mills convert',
		'IMPLEMENT.PROCESS.48': 'Штовхання',
		'IMPLEMENT.PROCESS.49': 'Передня/задня вага',
		'IMPLEMENT.PROCESS.5': 'Орання',
		'IMPLEMENT.PROCESS.50': 'Молотьба',
		'IMPLEMENT.PROCESS.51': 'Подрібнення',
		'IMPLEMENT.PROCESS.52': 'Пакетування тюків високого тиску',
		'IMPLEMENT.PROCESS.53': 'Unleafing',
		'IMPLEMENT.PROCESS.54': 'Стругання',
		'IMPLEMENT.PROCESS.55': 'Рілля',
		'IMPLEMENT.PROCESS.56': 'Підстригання',
		'IMPLEMENT.PROCESS.57': 'Монтажні роботи',
		'IMPLEMENT.PROCESS.58': 'Завантаження',
		'IMPLEMENT.PROCESS.59': 'Завантаження та розвантаження',
		'IMPLEMENT.PROCESS.6': 'Культивація',
		'IMPLEMENT.PROCESS.60': 'Мийка',
		'IMPLEMENT.PROCESS.61': 'Ущільнення',
		'IMPLEMENT.PROCESS.7': 'Боронування',
		'IMPLEMENT.PROCESS.8': 'Глибоке розпушування',
		'IMPLEMENT.PROCESS.9': 'Силове боронування',
		'IMPLEMENT.PROCESS.deadhead': 'Без знаряддя праці',
		'IMPLEMENT.REMOVE': 'Зніміть знаряддя',
		'IMPLEMENT.RESOURCE.0': 'не визначене',
		'IMPLEMENT.RESOURCE.1': 'Корм',
		'IMPLEMENT.RESOURCE.10': 'Навоз',
		'IMPLEMENT.RESOURCE.11': 'Рідкий навоз',
		'IMPLEMENT.RESOURCE.12': 'Компост',
		'IMPLEMENT.RESOURCE.13': 'Дигестат',
		'IMPLEMENT.RESOURCE.14': 'Щепки',
		'IMPLEMENT.RESOURCE.15': 'Кукурудза',
		'IMPLEMENT.RESOURCE.16': 'Соняшник',
		'IMPLEMENT.RESOURCE.17': 'Сорго',
		'IMPLEMENT.RESOURCE.18': 'Жито',
		'IMPLEMENT.RESOURCE.19': 'Тритикале',
		'IMPLEMENT.RESOURCE.2': 'Силос з трави',
		'IMPLEMENT.RESOURCE.20': 'Пшениця',
		'IMPLEMENT.RESOURCE.21': 'Боби польові',
		'IMPLEMENT.RESOURCE.22': 'Горох',
		'IMPLEMENT.RESOURCE.23': 'Польова трава',
		'IMPLEMENT.RESOURCE.24': 'Конюшинна трава',
		'IMPLEMENT.RESOURCE.25': 'Ячмінь',
		'IMPLEMENT.RESOURCE.26': 'Овес',
		'IMPLEMENT.RESOURCE.27': 'Пшениця спельта',
		'IMPLEMENT.RESOURCE.28': 'Камелина',
		'IMPLEMENT.RESOURCE.29': 'Лляне насіння',
		'IMPLEMENT.RESOURCE.3': 'Силос із цільних рослин',
		'IMPLEMENT.RESOURCE.30': 'Ріпак',
		'IMPLEMENT.RESOURCE.31': 'Соя',
		'IMPLEMENT.RESOURCE.32': 'Проміжна культура',
		'IMPLEMENT.RESOURCE.33': 'Цукровий буряк',
		'IMPLEMENT.RESOURCE.34': 'Картопля',
		'IMPLEMENT.RESOURCE.35': 'Міскантус',
		'IMPLEMENT.RESOURCE.36': 'Топінамбур',
		'IMPLEMENT.RESOURCE.37': 'Овочі',
		'IMPLEMENT.RESOURCE.38': 'Полуниця',
		'IMPLEMENT.RESOURCE.39': 'Рідке добриво',
		'IMPLEMENT.RESOURCE.4': 'Сіно',
		'IMPLEMENT.RESOURCE.40': 'Лайм',
		'IMPLEMENT.RESOURCE.41': 'Діаммонфосфат',
		'IMPLEMENT.RESOURCE.42': 'Haar flour pellets, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Сечовина',
		'IMPLEMENT.RESOURCE.44': 'Дизель',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Земля',
		'IMPLEMENT.RESOURCE.47': 'Засіб захисту рослин',
		'IMPLEMENT.RESOURCE.48': 'Різноманітний',
		'IMPLEMENT.RESOURCE.49': 'Вода',
		'IMPLEMENT.RESOURCE.5': 'ССМ',
		'IMPLEMENT.RESOURCE.50': 'Кормова суміш',
		'IMPLEMENT.RESOURCE.6': 'Кукурудза',
		'IMPLEMENT.RESOURCE.7': 'Солома',
		'IMPLEMENT.RESOURCE.8': 'Кукурудзяний силос',
		'IMPLEMENT.RESOURCE.9': 'Зерно',
		'IMPLEMENT.TYPE': 'Тип обладнання',
		'IMPLEMENT.TYPE.1': 'Прес-підбирачі/пакувальники',
		'IMPLEMENT.TYPE.10': 'Транспортні причепи',
		'IMPLEMENT.TYPE.10_1': 'Самоскид з тристоронним розвантаженням',
		'IMPLEMENT.TYPE.10_10': 'Низькорамний причіп',
		'IMPLEMENT.TYPE.10_11': 'Причіп з крюковим підйомником',
		'IMPLEMENT.TYPE.10_12': 'Причіп для перевезення худоби',
		'IMPLEMENT.TYPE.10_13': 'Напівпричіп візок',
		'IMPLEMENT.TYPE.10_14': 'Автоцистерни/Силоси',
		'IMPLEMENT.TYPE.10_2': 'Самоскид',
		'IMPLEMENT.TYPE.10_3': 'Бункер',
		'IMPLEMENT.TYPE.10_4': 'Платформа причіп',
		'IMPLEMENT.TYPE.10_5': 'Причіп кормозбиральний',
		'IMPLEMENT.TYPE.10_6': 'Причіп для силосу',
		'IMPLEMENT.TYPE.10_7': 'Причіп для перевезення тюків',
		'IMPLEMENT.TYPE.10_8': 'Причіп з висувною стінкою',
		'IMPLEMENT.TYPE.10_9': 'Цистерна для навоза',
		'IMPLEMENT.TYPE.11': 'Тваринницьке обладнання',
		'IMPLEMENT.TYPE.11_1': 'Причіпний змішувач кормів',
		'IMPLEMENT.TYPE.11_2': 'Кормороздавальний вагон',
		'IMPLEMENT.TYPE.11_3': 'Приймально-розвантажувальний вагон',
		'IMPLEMENT.TYPE.12': 'Лісне господарство',
		'IMPLEMENT.TYPE.12_1': 'Лісовий причіп',
		'IMPLEMENT.TYPE.12_2': 'Пила для дров',
		'IMPLEMENT.TYPE.12_3': 'дровокол',
		'IMPLEMENT.TYPE.12_4': 'Дровокол',
		'IMPLEMENT.TYPE.12_5': 'Подрібнювач пнів',
		'IMPLEMENT.TYPE.12_6': 'Лісогосподарська лебідка',
		'IMPLEMENT.TYPE.12_7': 'Лісовий мульчер',
		'IMPLEMENT.TYPE.12_8': 'Подрібнювач гілок',
		'IMPLEMENT.TYPE.12_8_1': 'Навісний дисковий подрібнювач',
		'IMPLEMENT.TYPE.12_8_2': 'Причіпний дисковий подрібнювач',
		'IMPLEMENT.TYPE.12_8_3': 'Навісний барабанний подрібнювач',
		'IMPLEMENT.TYPE.12_8_4': 'Причіпний барабанний подрібнювач',
		'IMPLEMENT.TYPE.12_8_5': 'Причіпний барабанний подрібнювач (самохідний)',
		'IMPLEMENT.TYPE.12_9': 'Гідравлічний кущоріз',
		'IMPLEMENT.TYPE.13': 'Комунальне обладнання',
		'IMPLEMENT.TYPE.13_1': 'Підмітальні машини',
		'IMPLEMENT.TYPE.13_10': 'Пристрій обслуговування шляху',
		'IMPLEMENT.TYPE.13_11': 'Банкетний фрезерний верстат',
		'IMPLEMENT.TYPE.13_12': 'Солонка - в зборі',
		'IMPLEMENT.TYPE.13_13': 'null',
		'IMPLEMENT.TYPE.13_14': 'Миючий пристрій',
		'IMPLEMENT.TYPE.13_15': 'Зрошувач',
		'IMPLEMENT.TYPE.13_16': 'Робоча площадка',
		'IMPLEMENT.TYPE.13_17': 'Поверхневий мульчувач',
		'IMPLEMENT.TYPE.13_18': 'Фронтальний аутригер',
		'IMPLEMENT.TYPE.13_18_1': 'Ріжуча головка',
		'IMPLEMENT.TYPE.13_18_2': 'Мульчуюча головка',
		'IMPLEMENT.TYPE.13_18_3': 'Тример для живоплоту',
		'IMPLEMENT.TYPE.13_18_4': 'Кліринговий кошик',
		'IMPLEMENT.TYPE.13_18_5': 'Граблі.',
		'IMPLEMENT.TYPE.13_19': 'Центр/структура аутригера',
		'IMPLEMENT.TYPE.13_19_1': 'Ріжуча головка',
		'IMPLEMENT.TYPE.13_19_2': 'Мульчуюча головка',
		'IMPLEMENT.TYPE.13_19_3': 'Тример для живоплоту',
		'IMPLEMENT.TYPE.13_19_4': 'Кліринговий кошик',
		'IMPLEMENT.TYPE.13_19_5': 'Граблі.',
		'IMPLEMENT.TYPE.13_1_1': 'Передня підмітальна машина',
		'IMPLEMENT.TYPE.13_1_2': 'Підмітальна машина',
		'IMPLEMENT.TYPE.13_1_3': 'структура',
		'IMPLEMENT.TYPE.13_2': 'Снігоочисник',
		'IMPLEMENT.TYPE.13_20': 'Задній аутригер',
		'IMPLEMENT.TYPE.13_20_1': 'Ріжуча головка',
		'IMPLEMENT.TYPE.13_20_2': 'Мульчуюча головка',
		'IMPLEMENT.TYPE.13_20_3': 'Тример для живоплоту',
		'IMPLEMENT.TYPE.13_20_4': 'Кліринговий кошик',
		'IMPLEMENT.TYPE.13_20_5': 'Граблі.',
		'IMPLEMENT.TYPE.13_21': 'Повітродувка для листя',
		'IMPLEMENT.TYPE.13_22': 'Банкетний ущільнювач / пластинчастий ущільнювач',
		'IMPLEMENT.TYPE.13_3': 'Снігоочисник - V-подібний',
		'IMPLEMENT.TYPE.13_4': 'Снігоочисник',
		'IMPLEMENT.TYPE.13_5': 'Навісний розкидач',
		'IMPLEMENT.TYPE.13_6': 'Буксируваний розкидач',
		'IMPLEMENT.TYPE.13_7': 'Придорожня косарка',
		'IMPLEMENT.TYPE.13_8': 'Косарка з виносної опорою',
		'IMPLEMENT.TYPE.13_9': 'Косарка',
		'IMPLEMENT.TYPE.14': 'Обладнання з фронтальним завантаженням',
		'IMPLEMENT.TYPE.14_1': 'Ковш',
		'IMPLEMENT.TYPE.14_2': 'Ковш великого об\'єму',
		'IMPLEMENT.TYPE.14_3': 'Вилка для піддонів',
		'IMPLEMENT.TYPE.14_4': 'Захват для тюків',
		'IMPLEMENT.TYPE.14_5': 'Вилка для тюків',
		'IMPLEMENT.TYPE.14_6': 'Ковш-захват',
		'IMPLEMENT.TYPE.14_7': 'Робоча площадка',
		'IMPLEMENT.TYPE.14_8': 'Вилка для гною',
		'IMPLEMENT.TYPE.15': 'Пристосування для збирання врожаю',
		'IMPLEMENT.TYPE.15_1': 'Різка',
		'IMPLEMENT.TYPE.15_1_1': 'Стандарт різки',
		'IMPLEMENT.TYPE.15_1_2': 'Cutting foldable',
		'IMPLEMENT.TYPE.15_2': 'Збирач кукурудзи',
		'IMPLEMENT.TYPE.15_2_1': 'Стандартний підбирач кукурудзи',
		'IMPLEMENT.TYPE.15_3': 'Кукурудзяна жатка',
		'IMPLEMENT.TYPE.15_4': 'GPS-Vorsatz',
		'IMPLEMENT.TYPE.15_5': 'Підбирач',
		'IMPLEMENT.TYPE.15_6': 'Кліринговий додаток',
		'IMPLEMENT.TYPE.15_7': 'Система впуску',
		'IMPLEMENT.TYPE.15_8': 'Підбирання валка',
		'IMPLEMENT.TYPE.16': 'Різне',
		'IMPLEMENT.TYPE.16_1': 'Мельниця CCM',
		'IMPLEMENT.TYPE.16_2': 'Передня вага',
		'IMPLEMENT.TYPE.16_3': 'Задня вага',
		'IMPLEMENT.TYPE.16_4': 'Штовхаюче лезо',
		'IMPLEMENT.TYPE.17': 'Фруктовий сад і виноградник',
		'IMPLEMENT.TYPE.17_1': 'Очисний плуг',
		'IMPLEMENT.TYPE.17_2': 'Посадочна машина',
		'IMPLEMENT.TYPE.17_3': 'Дефоліатор',
		'IMPLEMENT.TYPE.17_4': 'Фрезерний верстат',
		'IMPLEMENT.TYPE.18': 'Овочівництво',
		'IMPLEMENT.TYPE.18_1': 'Комбайн для збирання моркви',
		'IMPLEMENT.TYPE.18_2': 'Лукоуборочний комбайн',
		'IMPLEMENT.TYPE.18_4': 'Луковичний комбайн',
		'IMPLEMENT.TYPE.18_5': 'Комбайн для збирання цибулі-порею',
		'IMPLEMENT.TYPE.19': 'Технологія цукрових буряків',
		'IMPLEMENT.TYPE.19_1': 'Бурякозбиральний комбайн - комбайн бункерний',
		'IMPLEMENT.TYPE.19_1_1': 'Бункерний комбайн',
		'IMPLEMENT.TYPE.19_1_2': 'Перевантажувач',
		'IMPLEMENT.TYPE.1_1': 'Прес-підбирач рулонний',
		'IMPLEMENT.TYPE.1_2': 'Прес-підбирач квадратний',
		'IMPLEMENT.TYPE.1_3': 'Комбінація пакетування/упаковки',
		'IMPLEMENT.TYPE.1_4': 'Обмотувальник тюків',
		'IMPLEMENT.TYPE.1_5': 'Прес-підбирач високої щільності',
		'IMPLEMENT.TYPE.2': 'Обробка грунту',
		'IMPLEMENT.TYPE.2_1': 'Плуг',
		'IMPLEMENT.TYPE.2_10': 'Ротаційний культиватор',
		'IMPLEMENT.TYPE.2_10_1': 'Ротаційна фреза - навісна',
		'IMPLEMENT.TYPE.2_10_2': 'Ротаційний румпель - додається',
		'IMPLEMENT.TYPE.2_11': 'Передній пакувальник',
		'IMPLEMENT.TYPE.2_12': 'Ролик',
		'IMPLEMENT.TYPE.2_12_1': 'Ролик - навісний',
		'IMPLEMENT.TYPE.2_12_2': 'Ролик - додається',
		'IMPLEMENT.TYPE.2_13': 'Ротаційні борони',
		'IMPLEMENT.TYPE.2_13_1': 'Ротаційні борони - навісні',
		'IMPLEMENT.TYPE.2_13_2': 'Ротаційні борони - в комплекті',
		'IMPLEMENT.TYPE.2_14': 'Ротаційний культиватор',
		'IMPLEMENT.TYPE.2_14_1': 'Ротаційний культиватор - навісний',
		'IMPLEMENT.TYPE.2_14_2': 'Ротаційний культиватор - додається',
		'IMPLEMENT.TYPE.2_15': 'Передпосівна комбінація',
		'IMPLEMENT.TYPE.2_15_1': 'Посівна комбінація - навісна',
		'IMPLEMENT.TYPE.2_15_2': 'Посівна комбінація - додається',
		'IMPLEMENT.TYPE.2_16': 'Преси',
		'IMPLEMENT.TYPE.2_17': 'Скребки',
		'IMPLEMENT.TYPE.2_17_1': 'Скребки - навісні',
		'IMPLEMENT.TYPE.2_17_2': 'Скребки - додаються',
		'IMPLEMENT.TYPE.2_18': 'Солом\'яна борона',
		'IMPLEMENT.TYPE.2_18_1': 'Борона для соломи - навісна',
		'IMPLEMENT.TYPE.2_18_2': 'Борона для соломи - додається',
		'IMPLEMENT.TYPE.2_19': 'Зубчастий культиватор/культиватор',
		'IMPLEMENT.TYPE.2_19_1': 'Змонтовано додаткові культиватори - змонтовано',
		'IMPLEMENT.TYPE.2_19_2': 'Інші культиватори - додаються',
		'IMPLEMENT.TYPE.2_1_1': 'Навісний плуг',
		'IMPLEMENT.TYPE.2_1_2': 'Напівнавісний плуг',
		'IMPLEMENT.TYPE.2_1_3': 'Плуг полунавесной (наземний)',
		'IMPLEMENT.TYPE.2_2': 'Культиватор',
		'IMPLEMENT.TYPE.2_20': 'Інші культиватори',
		'IMPLEMENT.TYPE.2_2_1': 'Навісний культиватор',
		'IMPLEMENT.TYPE.2_2_2': 'Напівнавісний культиватор',
		'IMPLEMENT.TYPE.2_3': 'Дискова борона',
		'IMPLEMENT.TYPE.2_3_1': 'Навісна дискова борона',
		'IMPLEMENT.TYPE.2_3_2': 'Напівнавісна борона',
		'IMPLEMENT.TYPE.2_4': 'Компактна дискова борона',
		'IMPLEMENT.TYPE.2_4_1': 'Компактна дискова борона - навісна',
		'IMPLEMENT.TYPE.2_4_2': 'Компактна дискова борона - додається',
		'IMPLEMENT.TYPE.2_5': 'Глибокорозпушувач',
		'IMPLEMENT.TYPE.2_5_1': 'Глибокорозпушувач - навісний',
		'IMPLEMENT.TYPE.2_5_2': 'Глибокорозпушувач - додається',
		'IMPLEMENT.TYPE.2_6': 'Лопаточна машина',
		'IMPLEMENT.TYPE.2_6_1': 'Копач - навісний',
		'IMPLEMENT.TYPE.2_6_2': 'Піскорозкидач - додається',
		'IMPLEMENT.TYPE.2_7': 'Ротаційна борона',
		'IMPLEMENT.TYPE.2_7_1': 'Ротаційна борона - навісна',
		'IMPLEMENT.TYPE.2_7_2': 'Ротаційна борона - додається',
		'IMPLEMENT.TYPE.2_8': 'Ротаційна мотига',
		'IMPLEMENT.TYPE.2_8_1': 'Ротаційна мотика - навісна',
		'IMPLEMENT.TYPE.2_8_2': 'Ротаційна мотика - додається',
		'IMPLEMENT.TYPE.2_9': 'Поршнева борона',
		'IMPLEMENT.TYPE.2_9_1': 'Борона поршнева - навісна',
		'IMPLEMENT.TYPE.2_9_2': 'Борона зворотно-поступального руху - додається',
		'IMPLEMENT.TYPE.3': 'Сівалки/сівалки',
		'IMPLEMENT.TYPE.3_1': 'Механічна сівалка',
		'IMPLEMENT.TYPE.3_1_1': 'Навісна сівалка',
		'IMPLEMENT.TYPE.3_1_2': 'Сівалка напівнавісна',
		'IMPLEMENT.TYPE.3_1_3': 'Навісна посівна комбінація',
		'IMPLEMENT.TYPE.3_1_4': 'Напівнавісна посівна комбінація',
		'IMPLEMENT.TYPE.3_2': 'Пневматична сівалка',
		'IMPLEMENT.TYPE.3_2_1': 'Навісна сівалка',
		'IMPLEMENT.TYPE.3_2_2': 'напівнавісна сівалка',
		'IMPLEMENT.TYPE.3_2_3': 'Навісна посівна комбінація',
		'IMPLEMENT.TYPE.3_2_4': 'напівнавісна посівна комбінація',
		'IMPLEMENT.TYPE.3_3': 'механічна сівалка точного висіву',
		'IMPLEMENT.TYPE.3_3_1': 'Навісна сівалка',
		'IMPLEMENT.TYPE.3_3_2': 'напівнавісна сівалка',
		'IMPLEMENT.TYPE.3_3_3': 'Навісна посівна комбінація',
		'IMPLEMENT.TYPE.3_3_4': 'напівнавісна посівна комбінація',
		'IMPLEMENT.TYPE.3_4': 'Сівалка точного висіву',
		'IMPLEMENT.TYPE.3_4_1': 'Навісна сівалка',
		'IMPLEMENT.TYPE.3_4_2': 'напівнавісна сівалка',
		'IMPLEMENT.TYPE.3_4_3': 'Навісна посівна комбінація',
		'IMPLEMENT.TYPE.3_4_4': 'Напівнавісна посівна комбінація',
		'IMPLEMENT.TYPE.3_5': 'Сівалка пряма',
		'IMPLEMENT.TYPE.3_5_1': 'Сівалка прямого висіву - навісна',
		'IMPLEMENT.TYPE.3_5_2': 'Сівалка для прямого висіву - додається',
		'IMPLEMENT.TYPE.3_6': 'Сівалка прямого посіву точного висіву',
		'IMPLEMENT.TYPE.3_6_1': 'Однозернова сівалка прямого висіву - навісна',
		'IMPLEMENT.TYPE.3_6_2': 'Однозернова сівалка прямого висіву - додається',
		'IMPLEMENT.TYPE.3_7': 'Сівалка',
		'IMPLEMENT.TYPE.3_7_1': 'Сівалка - навісна',
		'IMPLEMENT.TYPE.3_7_2': 'Сівалка - додається',
		'IMPLEMENT.TYPE.3_8': 'Сівалка для трави',
		'IMPLEMENT.TYPE.3_8_1': 'Сівалка для пасовищ - навісна',
		'IMPLEMENT.TYPE.3_8_2': 'Сівалка для пасовищ - додається',
		'IMPLEMENT.TYPE.3_9': 'Передній бак',
		'IMPLEMENT.TYPE.4': 'Розкидач',
		'IMPLEMENT.TYPE.4_1': 'Навісний розкидач',
		'IMPLEMENT.TYPE.4_2': 'напівнавісний розкидач',
		'IMPLEMENT.TYPE.5': 'Захист рослин',
		'IMPLEMENT.TYPE.5_1': 'Обприскувач навісний',
		'IMPLEMENT.TYPE.5_2': 'Причіпний обприскувач',
		'IMPLEMENT.TYPE.5_3': 'Прополювальна/мотика',
		'IMPLEMENT.TYPE.5_3_1': 'Мотика - навісна',
		'IMPLEMENT.TYPE.5_3_2': 'Мотика - додається',
		'IMPLEMENT.TYPE.5_4': '\"Бур\'ян',
		'IMPLEMENT.TYPE.5_4_1': 'Прополювач - навісний',
		'IMPLEMENT.TYPE.5_4_2': 'Прополювач - додається',
		'IMPLEMENT.TYPE.6': 'Технологія навоза',
		'IMPLEMENT.TYPE.6_1': 'Розкидувач навоза / компосту',
		'IMPLEMENT.TYPE.6_2': 'Цистерна для рідкого навозу',
		'IMPLEMENT.TYPE.6_2_1': 'Точний розсіювач',
		'IMPLEMENT.TYPE.6_2_2': 'Штанга крапельного шлангу',
		'IMPLEMENT.TYPE.6_2_3': 'Розкидувач причіпних башмаків',
		'IMPLEMENT.TYPE.6_2_4': 'Інжектор культиватора',
		'IMPLEMENT.TYPE.6_2_5': 'Інжектор дискової борони',
		'IMPLEMENT.TYPE.6_2_6': 'Форсунка дискового ножа',
		'IMPLEMENT.TYPE.6_2_7': 'Striptill Injektor',
		'IMPLEMENT.TYPE.6_2_8': 'Поворотний розподільник',
		'IMPLEMENT.TYPE.6_3': 'Насос для рідкого навоза',
		'IMPLEMENT.TYPE.6_4': 'Міксер рідкого навоза',
		'IMPLEMENT.TYPE.6_5': 'Контейнер для рідкого навоза',
		'IMPLEMENT.TYPE.6_6': 'Шлангова система',
		'IMPLEMENT.TYPE.6_6_1': 'Тяговий розподільник шланга',
		'IMPLEMENT.TYPE.6_6_2': 'Drag shoe distributor',
		'IMPLEMENT.TYPE.6_6_3': 'Дисковий інжектор для рідкого навоза',
		'IMPLEMENT.TYPE.6_6_4': 'Культиватор для рідкого навоза',
		'IMPLEMENT.TYPE.6_6_5': 'Дискова борона для внесення добрив',
		'IMPLEMENT.TYPE.6_6_6': 'Інжектор рідкого навоза',
		'IMPLEMENT.TYPE.6_6_7': 'Поворотний розподілювач',
		'IMPLEMENT.TYPE.7': 'Технологія зрошення',
		'IMPLEMENT.TYPE.7_1': 'Мандрівник по зрошенню',
		'IMPLEMENT.TYPE.7_2': 'Зрошувальна стріла',
		'IMPLEMENT.TYPE.8': 'Обладнання для картоплі',
		'IMPLEMENT.TYPE.8_1': 'Картопляна сівалка',
		'IMPLEMENT.TYPE.8_1_1': 'Сівалка без роторного культиватора',
		'IMPLEMENT.TYPE.8_1_2': 'Сівалка з роторним культиватором',
		'IMPLEMENT.TYPE.8_1_3': 'Посадкова машина без ротаційної борони / навісного культиватора',
		'IMPLEMENT.TYPE.8_1_4': 'Посадкова машина з ротаційної бороною / навісним культиватором',
		'IMPLEMENT.TYPE.8_2': 'Картоплезбиральний комбайн - косарка',
		'IMPLEMENT.TYPE.8_3': 'Картоплезбиральний комбайн - з бункером',
		'IMPLEMENT.TYPE.8_4': 'Картоплезбиральний комбайн - елеватор',
		'IMPLEMENT.TYPE.8_5': 'Ridge former',
		'IMPLEMENT.TYPE.8_6': 'Сепаратор',
		'IMPLEMENT.TYPE.8_7': 'Роторный окучник',
		'IMPLEMENT.TYPE.8_8': 'Ботворіз',
		'IMPLEMENT.TYPE.9': 'Обладнання для пасовищ',
		'IMPLEMENT.TYPE.9_1': 'Барабанна косарка',
		'IMPLEMENT.TYPE.9_1_1': 'Барабанна косарка з плющилкою',
		'IMPLEMENT.TYPE.9_1_2': 'Барабанна косарка без плющилки',
		'IMPLEMENT.TYPE.9_1_3': 'Барабанна косарка з плющилкою',
		'IMPLEMENT.TYPE.9_1_4': 'Барабанна косарка без плющилки',
		'IMPLEMENT.TYPE.9_2': 'Дискова косарка',
		'IMPLEMENT.TYPE.9_2_1': 'Дискова косарка з плющилкою',
		'IMPLEMENT.TYPE.9_2_2': 'Дискова косарка без плющилки',
		'IMPLEMENT.TYPE.9_2_3': 'Дискова косарка з плющилкою',
		'IMPLEMENT.TYPE.9_2_4': 'Дискова косарка без плющилки',
		'IMPLEMENT.TYPE.9_3': 'Ротаційна сіноворушилка',
		'IMPLEMENT.TYPE.9_3_1': 'Сіноворушилка / сіноворушилка з навісним обладнанням',
		'IMPLEMENT.TYPE.9_3_2': 'Приставлена роторна ворушилка',
		'IMPLEMENT.TYPE.9_4': 'Валкователь',
		'IMPLEMENT.TYPE.9_4_1': 'Валкователь з одним ротором',
		'IMPLEMENT.TYPE.9_4_2': 'Валкоукладчик двороторний (бокове укладання валка)',
		'IMPLEMENT.TYPE.9_4_3': 'Валкователь з двома роторами (центральне укладання валка)',
		'IMPLEMENT.TYPE.9_4_4': 'Валкователь чотирьохроторний',
		'IMPLEMENT.TYPE.9_4_5': 'Безперервне злиття',
		'IMPLEMENT.TYPE.9_4_6': 'Роторні граблі',
		'IMPLEMENT.TYPE.9_5': 'Борона для лугів',
		'IMPLEMENT.TYPE.9_6': 'Пасовищна борона',
		'IMPLEMENT.TYPE.9_7': 'Каток для луга',
		'IMPLEMENT.TYPE.9_8': 'Подрібнювач',
		'IMPLEMENTS': 'Обладнання',
		'IMPLEMENTS.ALL': 'Все обладнання',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Деякі знаряддя не вдалося деактивувати.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати вибрані знаряддя?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Інструменти успішно деактивовано',
		'IMPLEMENTS.DELETE.FAILURE': 'Не вдалося видалити деяке обладнання',
		'IMPLEMENTS.DELETE.QUESTION': 'Ви дійсно хочете видалити вибране обладнання?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Обладнання видалено',
		'IMPLEMENTS.MANAGEMENT': 'Керування обладнанням',
		'IMPLEMENTS.NO': 'Немає обладнання',
		'IMPLEMENTS.NOT_SELECTED': 'Не вибрано жодного знаряддя',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Деякі з знарядь не вдалося відновити.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Ви дійсно хочете реактивувати вибрані знаряддя?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Знаряддя успішно реанімовано',
		'IMPLEMENTS.SELECTED': 'Вибране обладнання',
		'IMPLEMENT_SCAN_DISABLED': 'Сканування маячків обладнання неактивно',
		'IMPORT': 'Імпорт',
		'INACTIVE': 'Неактивно',
		'INDIVIDUAL_LABELING': 'Користувацьке маркування',
		'INFO': 'Інформація',
		'INTERPOLATION.MAP': 'Карта інтерполяції',
		'INTERPOLATION.MAP.SETTINGS': 'Налаштування карти інтерполяції',
		'IO_BOX_ACTIVATED': 'IOBox активний',
		'ISOBUS.DDI.1': 'Встановлений обсяг на одиницю площі норми внесення',
		'ISOBUS.DDI.10': 'Максимальна норма внесення маси на площу',
		'ISOBUS.DDI.100': 'Забруднення врожаю',
		'ISOBUS.DDI.101': 'Задана ширина тюка',
		'ISOBUS.DDI.102': 'Фактична ширина тюка',
		'ISOBUS.DDI.103': 'Ширина тюка за замовчуванням',
		'ISOBUS.DDI.104': 'Мінімальна ширина тюка',
		'ISOBUS.DDI.105': 'Максимальна ширина тюка',
		'ISOBUS.DDI.106': 'Задана висота тюка',
		'ISOBUS.DDI.107': 'Фактична висота тюка',
		'ISOBUS.DDI.108': 'Висота тюка за замовчуванням',
		'ISOBUS.DDI.109': 'Мінімальна висота тюка',
		'ISOBUS.DDI.11': 'Кількість даних значень на норму внесення',
		'ISOBUS.DDI.110': 'Максимальна висота тюка',
		'ISOBUS.DDI.111': 'Заданий розмір тюка',
		'ISOBUS.DDI.112': 'Фактичний розмір тюка',
		'ISOBUS.DDI.113': 'Розмір тюка за замовчуванням',
		'ISOBUS.DDI.114': 'Мінімальний розмір тюка',
		'ISOBUS.DDI.115': 'Максимальний розмір тюка',
		'ISOBUS.DDI.116': 'Загальна площа',
		'ISOBUS.DDI.117': 'Ефективна загальна відстань',
		'ISOBUS.DDI.118': 'Неефективна загальна відстань',
		'ISOBUS.DDI.119': 'Ефективний загальний час',
		'ISOBUS.DDI.12': 'Фактична кількість на норму внесення',
		'ISOBUS.DDI.120': 'Неефективний загальний час',
		'ISOBUS.DDI.121': 'Щільність маси на об\'єм',
		'ISOBUS.DDI.122': 'Щільність маси на рахунок',
		'ISOBUS.DDI.123': 'Обсяг щільності продукту на рахунок',
		'ISOBUS.DDI.124': 'Розширення шкали допоміжного клапана',
		'ISOBUS.DDI.125': 'Відведення шкали допоміжного клапана',
		'ISOBUS.DDI.126': 'Нахил допоміжного клапана висувається вгору',
		'ISOBUS.DDI.127': 'Рампа допоміжного клапана висувається вниз',
		'ISOBUS.DDI.128': 'Допоміжний клапан втягується з рампою вгору',
		'ISOBUS.DDI.129': 'Лінія втягування допоміжного клапана вниз',
		'ISOBUS.DDI.13': 'Кількість за замовчуванням на норму внесення',
		'ISOBUS.DDI.130': 'Поріг спрацьовування допоміжного клапана',
		'ISOBUS.DDI.131': 'Збільшення ходу допоміжного клапана',
		'ISOBUS.DDI.132': 'Втягування ходу допоміжного клапана',
		'ISOBUS.DDI.133': 'Отвори для зворотного клапана допоміжного клапана',
		'ISOBUS.DDI.134': 'Зсув елемента пристрою X',
		'ISOBUS.DDI.135': 'Зсув елемента пристрою Y',
		'ISOBUS.DDI.136': 'Зсув елемента пристрою Z',
		'ISOBUS.DDI.137': 'Об\'єм пристрою',
		'ISOBUS.DDI.138': 'Маса пристрою',
		'ISOBUS.DDI.139': 'Ємкість лічильника пристроїв',
		'ISOBUS.DDI.14': 'Мінімальна норма витрати на одиницю площі',
		'ISOBUS.DDI.140': 'Задане значення процентної норми внесення',
		'ISOBUS.DDI.141': 'Фактичний робочий стан',
		'ISOBUS.DDI.142': 'Установка затримки часу',
		'ISOBUS.DDI.143': 'Фактичне значення затримки часу',
		'ISOBUS.DDI.144': 'Кут нишпорення',
		'ISOBUS.DDI.145': 'Кут крену',
		'ISOBUS.DDI.146': 'Кут тангажу',
		'ISOBUS.DDI.147': 'Лічильник журналу',
		'ISOBUS.DDI.148': 'Загальна витрата палива',
		'ISOBUS.DDI.149': 'Миттєва витрата палива за час',
		'ISOBUS.DDI.15': 'Максимальна кількість на одну область норми внесення',
		'ISOBUS.DDI.150': 'Миттєва витрата палива на площу',
		'ISOBUS.DDI.151': 'Миттєва площа за час',
		'ISOBUS.DDI.153': 'Фактичний NDVI',
		'ISOBUS.DDI.154': 'Фізична довжина об\'єкта',
		'ISOBUS.DDI.155': 'Фізична ширина об\'єкта',
		'ISOBUS.DDI.156': 'Фізична висота об\'єкта',
		'ISOBUS.DDI.157': 'Тип роз\'єму',
		'ISOBUS.DDI.158': 'Припис стану контролю',
		'ISOBUS.DDI.159': 'Кількість підрозділів в секції',
		'ISOBUS.DDI.16': 'Інтервал уставки норми внесення',
		'ISOBUS.DDI.160': 'Стан управління секціями',
		'ISOBUS.DDI.161': 'Робоче положення (вкл / викл) окремих секцій (1-16) по всій ширині захоплення',
		'ISOBUS.DDI.162': 'Робоче положення (вкл / викл) окремих секцій (17-32) по всій ширині захоплення',
		'ISOBUS.DDI.163': 'Робоче положення (вкл / викл) окремих секцій (33-48) по всій ширині захоплення',
		'ISOBUS.DDI.164': 'Робоче положення (вкл / викл) окремих секцій (49-64) по всій ширині захоплення',
		'ISOBUS.DDI.165': 'Робоче положення (вкл / викл) окремих секцій (65-80) по всій ширині захоплення',
		'ISOBUS.DDI.166': 'Робоче положення (вкл / викл) окремих секцій (81-96) по всій ширині захоплення',
		'ISOBUS.DDI.167': 'Робоче положення (вкл / викл) окремих секцій (97-112) по всій ширині захоплення',
		'ISOBUS.DDI.168': 'Робоче положення (вкл / викл) окремих секцій (113-128) по всій ширині захоплення',
		'ISOBUS.DDI.169': 'Робоче положення (вкл / викл) окремих секцій (129-144) по всій ширині захоплення',
		'ISOBUS.DDI.17': 'Фактична норма внесення',
		'ISOBUS.DDI.170': 'Робоче положення (вкл / викл) окремих секцій (145-160) по всій ширині захоплення',
		'ISOBUS.DDI.171': 'Робоче положення (вкл / викл) окремих секцій (161-176) по всій ширині захоплення',
		'ISOBUS.DDI.172': 'Робоче положення (вкл / викл) окремих секцій (177-192) по всій ширині захоплення',
		'ISOBUS.DDI.173': 'Робоче положення (вкл / викл) окремих секцій (193-208) по всій ширині захоплення',
		'ISOBUS.DDI.174': 'Робоче положення (вкл / викл) окремих секцій (209-224) по всій ширині захоплення',
		'ISOBUS.DDI.175': 'Робоче положення (вкл / викл) окремих секцій (225-240) по всій ширині захоплення',
		'ISOBUS.DDI.176': 'Робоче положення (вкл / викл) окремих секцій (241-256) по всій ширині захоплення',
		'ISOBUS.DDI.177': 'Фактична довжина різу',
		'ISOBUS.DDI.178': 'Тип элемента Instance',
		'ISOBUS.DDI.179': 'Фактична культурна практика',
		'ISOBUS.DDI.18': 'Інтервал норми внесення за замовчуванням',
		'ISOBUS.DDI.180': 'Відстань від контрольної точки пристрою (DRP) до землі',
		'ISOBUS.DDI.181': 'Суха маса на площу врожаю',
		'ISOBUS.DDI.182': 'Суха маса на час врожаю',
		'ISOBUS.DDI.183': 'Вихід загальної сухої маси',
		'ISOBUS.DDI.184': 'Еталонна вологість для сухої маси',
		'ISOBUS.DDI.185': 'Маса насіння бавовни з площі врожаю',
		'ISOBUS.DDI.186': 'Маса волокна бавовни на площу виходу',
		'ISOBUS.DDI.187': 'Маса насіння бавовни за час врожайності',
		'ISOBUS.DDI.188': 'Маса бавовняного волокна за час виходу',
		'ISOBUS.DDI.189': 'Загальна маса врожаю насіння бавовни',
		'ISOBUS.DDI.19': 'Мінімальна норма внесення',
		'ISOBUS.DDI.190': 'Загальний вихід бавовняної маси',
		'ISOBUS.DDI.191': 'Відсоток виходу бавовняної маси',
		'ISOBUS.DDI.192': 'Температура навколишнього середовища',
		'ISOBUS.DDI.193': 'Задане значення тиску продукту',
		'ISOBUS.DDI.194': 'Фактичний тиск продукту',
		'ISOBUS.DDI.195': 'Мінімальний тиск продукту',
		'ISOBUS.DDI.196': 'Максимальний тиск продукту',
		'ISOBUS.DDI.197': 'Встановлене значення вихідного тиску насоса',
		'ISOBUS.DDI.198': 'Фактичний тиск вихідного насоса',
		'ISOBUS.DDI.199': 'Мінімальне значення вихідного тиску насоса',
		'ISOBUS.DDI.2': 'Фактичний обсяг норми внесення на площу',
		'ISOBUS.DDI.20': 'Максимальна норма внесення',
		'ISOBUS.DDI.200': 'Максимальне значення вихідного тиску насоса',
		'ISOBUS.DDI.201': 'Установка тиску перемішування у резервуарі',
		'ISOBUS.DDI.202': 'Фактичне значення тиску перемішування у резервуарі',
		'ISOBUS.DDI.203': 'Мінімальний тиск перемішування у резервуарі',
		'ISOBUS.DDI.204': 'Максимальний тиск перемішування у резервуарі',
		'ISOBUS.DDI.205': 'Час включення управління секціями',
		'ISOBUS.DDI.206': 'Час виключення управління секціями',
		'ISOBUS.DDI.207': 'Швидкість вітру',
		'ISOBUS.DDI.208': 'Напрямок вітру',
		'ISOBUS.DDI.209': 'Відносна вологість',
		'ISOBUS.DDI.21': 'Задане значення обсягу на обсяг норми внесення',
		'ISOBUS.DDI.210': 'Ступінь покриття неба',
		'ISOBUS.DDI.211': 'Кількість ходів ущільнення останнього тюка',
		'ISOBUS.DDI.212': 'Середня вологість останнього тюка',
		'ISOBUS.DDI.213': 'Кількість ходів гофрування за один хід ущільнення останнього тюка',
		'ISOBUS.DDI.214': 'Лічильник тюків за весь період',
		'ISOBUS.DDI.215': 'Години роботи за весь термін служби',
		'ISOBUS.DDI.216': 'Фактичний гідравлічний тиск тюка',
		'ISOBUS.DDI.217': 'Останній середній гідравлічний тиск тюка',
		'ISOBUS.DDI.218': 'Встановлене навантаження на плунжер стиснення тюка',
		'ISOBUS.DDI.219': 'Фактичне значення навантаження на плунжер стиснення тюка',
		'ISOBUS.DDI.22': 'Фактичний обсяг на об\'ємну норму внесення',
		'ISOBUS.DDI.220': 'Остання середнє навантаження на плунжер стиснення тюка',
		'ISOBUS.DDI.221': 'Останній тюк внесеного консерванту',
		'ISOBUS.DDI.222': 'Номер бирки останнього тюка',
		'ISOBUS.DDI.223': 'Маса останнього тюка',
		'ISOBUS.DDI.224': 'Дельта Т',
		'ISOBUS.DDI.225': 'Задана робоча довжина',
		'ISOBUS.DDI.226': 'Фактична робоча довжина',
		'ISOBUS.DDI.227': 'Мінімальна робоча довжина',
		'ISOBUS.DDI.228': 'Максимальна робоча довжина',
		'ISOBUS.DDI.229': 'Фактична вага нетто',
		'ISOBUS.DDI.23': 'Обсяг за замовчуванням на обсяг норми внесення',
		'ISOBUS.DDI.230': 'Стан ваги нетто',
		'ISOBUS.DDI.231': 'Встановлена вага нетто',
		'ISOBUS.DDI.232': 'Фактична вага брутто',
		'ISOBUS.DDI.233': 'Стан ваги брутто',
		'ISOBUS.DDI.234': 'Мінімальна вага брутто',
		'ISOBUS.DDI.235': 'Максимальна вага брутто',
		'ISOBUS.DDI.236': 'Загальний час з молотаркою',
		'ISOBUS.DDI.237': 'Фактичний стан робочої висоти жатки',
		'ISOBUS.DDI.238': 'Actual Header Rotational Speed Status',
		'ISOBUS.DDI.239': 'Статус утримання врожаю',
		'ISOBUS.DDI.24': 'Мінімальний обсяг на обсяг норми внесення',
		'ISOBUS.DDI.240': 'Фактичний стан системи завантаження (розвантаження)',
		'ISOBUS.DDI.241': 'Температура врожаю',
		'ISOBUS.DDI.242': 'Встановлений зазор сита',
		'ISOBUS.DDI.243': 'Фактичний зазор сита',
		'ISOBUS.DDI.244': 'Мінімальне значення зазору сита',
		'ISOBUS.DDI.245': 'Максимальне значення зазору сита',
		'ISOBUS.DDI.246': 'Встановлена відстань секцій',
		'ISOBUS.DDI.247': 'Фактична відстань секцій',
		'ISOBUS.DDI.248': 'Мінімальна відстань секцій',
		'ISOBUS.DDI.249': 'Максимальна відстань секцій',
		'ISOBUS.DDI.25': 'Максимальний обсяг на обсяг норми внесення',
		'ISOBUS.DDI.250': 'Задане значення зазору підбарабання',
		'ISOBUS.DDI.251': 'Фактичне значення зазору підбарабання',
		'ISOBUS.DDI.252': 'Мінімальне значення зазору підбарабання',
		'ISOBUS.DDI.253': 'Максимальне значення зазору підбарабання',
		'ISOBUS.DDI.254': 'Задана швидкість обертання вентилятора відділення',
		'ISOBUS.DDI.255': 'Фактична швидкість обертання вентилятора відділення',
		'ISOBUS.DDI.256': 'Мінімальна швидкість обертання вентилятора відділення',
		'ISOBUS.DDI.257': 'Максимальна швидкість обертання вентилятора відділення',
		'ISOBUS.DDI.258': 'Температура гідравлічного масла',
		'ISOBUS.DDI.259': 'Час ігнорування отримання даних по врожайності',
		'ISOBUS.DDI.26': 'Задане значення маси на масову норму внесення',
		'ISOBUS.DDI.260': 'Час ігнорування випередження врожаю',
		'ISOBUS.DDI.261': 'Середня маса врожаю за час',
		'ISOBUS.DDI.262': 'Середня вологість врожаю',
		'ISOBUS.DDI.263': 'Середня маса врожаю з площі',
		'ISOBUS.DDI.264': 'З\'єднувач Pivot X-Offset',
		'ISOBUS.DDI.265': 'Площа, що залишилась',
		'ISOBUS.DDI.266': 'Загальна маса внесення за весь термін служби',
		'ISOBUS.DDI.267': 'Загальна кількість внесень за весь термін служби',
		'ISOBUS.DDI.268': 'Загальний обсяг врожаю за весь період',
		'ISOBUS.DDI.269': 'Загальна маса врожаю за весь період',
		'ISOBUS.DDI.27': 'Фактична масова норма внесення',
		'ISOBUS.DDI.270': 'Загальна кількість врожаю за весь період',
		'ISOBUS.DDI.271': 'Загальна площа за весь період',
		'ISOBUS.DDI.272': 'Ефективна загальна відстань за весь період',
		'ISOBUS.DDI.273': 'Неефективна загальна відстань за весь період',
		'ISOBUS.DDI.274': 'Ефективний загальний час за весь період',
		'ISOBUS.DDI.275': 'Неефективний загальний час за весь період',
		'ISOBUS.DDI.276': 'Витрата палива за весь період',
		'ISOBUS.DDI.277': 'Середня витрата палива за весь період',
		'ISOBUS.DDI.278': 'Середня витрата палива на площу за весь період',
		'ISOBUS.DDI.279': 'Загальна суха маса врожаю за весь період',
		'ISOBUS.DDI.28': 'Норма масового внесення за замовчуванням',
		'ISOBUS.DDI.280': 'Загальна маса насіння бавовни за весь період',
		'ISOBUS.DDI.281': 'Загальна маса бавовни за весь період',
		'ISOBUS.DDI.282': 'Загальний час виконання обмолоту за весь період',
		'ISOBUS.DDI.283': 'Загальна кількість попередньо розрізаних матеріалів',
		'ISOBUS.DDI.284': 'Загальна кількість нерозрізаних матеріалів',
		'ISOBUS.DDI.285': 'Загальна кількість попередніх нарізок за весь період',
		'ISOBUS.DDI.286': 'Загальна кількість нерозрізаних матеріалів за весь період',
		'ISOBUS.DDI.287': 'Задане значення режиму припису',
		'ISOBUS.DDI.288': 'Фактичне значення режиму припису',
		'ISOBUS.DDI.289': 'Задане значення робочого стану',
		'ISOBUS.DDI.29': 'Мінімальна масова норма внесення',
		'ISOBUS.DDI.290': 'Задане робоче положення секцій з 1 по 16',
		'ISOBUS.DDI.291': 'Задане робоче положення секцій з 17 по 32',
		'ISOBUS.DDI.292': 'Задане робоче положення секцій з 33 по 48',
		'ISOBUS.DDI.293': 'Задане робоче положення секцій з 49 по 64',
		'ISOBUS.DDI.294': 'Задане робоче положення секцій з 65 по 80',
		'ISOBUS.DDI.295': 'Задане робоче положення секцій з 81 по 96',
		'ISOBUS.DDI.296': 'Задане робоче положення секцій з 97 по 112',
		'ISOBUS.DDI.297': 'Задане робоче положення секцій з 113 по 128',
		'ISOBUS.DDI.298': 'Задане робоче положення секцій з 129 по 144',
		'ISOBUS.DDI.299': 'Задане робоче положення секцій з 145 по 160',
		'ISOBUS.DDI.3': 'Обсяг за замовчуванням на норму внесення',
		'ISOBUS.DDI.30': 'Максимальна масова норма внесення',
		'ISOBUS.DDI.300': 'Задане робоче положення секцій з 161 по 176',
		'ISOBUS.DDI.301': 'Задане робоче положення секцій з 177 по 192',
		'ISOBUS.DDI.302': 'Задане робоче положення секцій з 193 по 208',
		'ISOBUS.DDI.303': 'Задане робоче положення секцій з 209 по 224',
		'ISOBUS.DDI.304': 'Задане робоче положення секцій з 225 по 240',
		'ISOBUS.DDI.305': 'Задане робоче положення секцій з 241 по 256',
		'ISOBUS.DDI.306': 'Істинне зміщення точки обертання по осі X',
		'ISOBUS.DDI.307': 'Істинне зміщення точки обертання по осі Y',
		'ISOBUS.DDI.308': 'Фактична процентна норма внесення',
		'ISOBUS.DDI.309': 'Мінімальна процентна норма внесення',
		'ISOBUS.DDI.31': 'Встановлений об\'єм на масову норму внесення',
		'ISOBUS.DDI.310': 'Максимальна процентна норма внесення',
		'ISOBUS.DDI.311': 'Відносний потенціал прибутковості',
		'ISOBUS.DDI.312': 'Мінімальна відносна прибутковість',
		'ISOBUS.DDI.313': 'Максимальна відносна прибутковість',
		'ISOBUS.DDI.314': 'Фактичний відсотковий вміст сухої речовини',
		'ISOBUS.DDI.315': 'Середній відсотковий вміст сухої речовини',
		'ISOBUS.DDI.316': 'Ефективна загальна витрата палива',
		'ISOBUS.DDI.317': 'Неефективна загальна витрата палива',
		'ISOBUS.DDI.318': 'Ефективна загальна витрата дизельної вихлопної рідини',
		'ISOBUS.DDI.319': 'Неефективна загальна витрата дизельної вихлопної рідини',
		'ISOBUS.DDI.32': 'Фактичний обсяг на масову норму внесення',
		'ISOBUS.DDI.320': 'Вага останнього завантаження',
		'ISOBUS.DDI.321': 'Вага останньго розвантаження',
		'ISOBUS.DDI.322': 'Завантажити ідентифікаційний номер',
		'ISOBUS.DDI.323': 'Вивантажити ідентифікаційний номер',
		'ISOBUS.DDI.324': 'Загальний час включення подрібнювача',
		'ISOBUS.DDI.325': 'Загальний обсяг внесення за весь період',
		'ISOBUS.DDI.326': 'Задана частота обертання',
		'ISOBUS.DDI.327': 'Актуальна частота обертання',
		'ISOBUS.DDI.328': 'Мінімальна частота обертання',
		'ISOBUS.DDI.329': 'Максимальна частота обертання',
		'ISOBUS.DDI.33': 'Обсяг за замовчуванням на масову норму внесення',
		'ISOBUS.DDI.330': 'Задане значення швидкості ріжучого барабана',
		'ISOBUS.DDI.331': 'Фактичне значення швидкості ріжучого барабана',
		'ISOBUS.DDI.332': 'Мінімальне значення швидкості ріжучого барабана',
		'ISOBUS.DDI.333': 'Максимальне значення швидкості ріжучого барабана',
		'ISOBUS.DDI.334': 'Години роботи з моменту останньої заточки',
		'ISOBUS.DDI.335': 'Фронтальний ВВП години',
		'ISOBUS.DDI.336': 'Задній ВВП години',
		'ISOBUS.DDI.337': 'Години роботи переднього ВВП за весь період',
		'ISOBUS.DDI.338': 'Години роботи заднього ВВП за весь період',
		'ISOBUS.DDI.339': 'Ефективний загальний час завантаження',
		'ISOBUS.DDI.34': 'Мінімальний обсяг на масову норму внесення',
		'ISOBUS.DDI.340': 'Ефективний загальний час розвантаження',
		'ISOBUS.DDI.341': 'Заданий зазор барабанів дробилки зерна в подрібнювачі',
		'ISOBUS.DDI.342': 'Фактичний зазор барабанів дробилки зерна в подрібнювачі',
		'ISOBUS.DDI.343': 'Мінімальний зазор барабанів дробилки зерна в подрібнювачі',
		'ISOBUS.DDI.344': 'Максимальний зазор барабанів дробилки зерна в подрібнювачі',
		'ISOBUS.DDI.345': 'Задана ширина валкування',
		'ISOBUS.DDI.346': 'Фактична ширина валкування',
		'ISOBUS.DDI.347': 'Мінімальна ширина валкування',
		'ISOBUS.DDI.348': 'Максимальна ширина валкування',
		'ISOBUS.DDI.349': 'Зниження зносу сопла',
		'ISOBUS.DDI.35': 'Максимальний об\'єм на масову норму внесення',
		'ISOBUS.DDI.350': 'Функція або техніка роботи',
		'ISOBUS.DDI.351': 'Загальний об\'єм внесення',
		'ISOBUS.DDI.352': 'Загальна маса внесення',
		'ISOBUS.DDI.353': 'Загальне внесення азоту',
		'ISOBUS.DDI.354': 'Загальне внесення амонію',
		'ISOBUS.DDI.355': 'Загальне внесення фосфору',
		'ISOBUS.DDI.356': 'Загальний обсяг внесення калію',
		'ISOBUS.DDI.357': 'Загальне внесення сухої речовини',
		'ISOBUS.DDI.358': 'Середня суха маса за час',
		'ISOBUS.DDI.359': 'Середня суха маса на площу',
		'ISOBUS.DDI.36': 'Заданий значення обсягу за час норми внесення',
		'ISOBUS.DDI.360': 'Розмір останнього тюка',
		'ISOBUS.DDI.361': 'Щільність останнього тюка',
		'ISOBUS.DDI.362': 'Загальна довжина тюка',
		'ISOBUS.DDI.363': 'Суха маса останнього тюка',
		'ISOBUS.DDI.364': 'Фактичний розмір неповного тюка',
		'ISOBUS.DDI.365': 'Встановлений тиск прижимної сили',
		'ISOBUS.DDI.366': 'Фактичний тиск прижимної сили',
		'ISOBUS.DDI.367': 'Стан блокування робочого положення одиниць 1-16',
		'ISOBUS.DDI.368': 'Стан блокування робочого положення одиниць 17-32',
		'ISOBUS.DDI.369': 'Стан блокування робочого положення одиниць 33-48',
		'ISOBUS.DDI.37': 'Фактичний обсяг за час норми внесення',
		'ISOBUS.DDI.370': 'Стан блокування робочого положення одиниць 49-64',
		'ISOBUS.DDI.371': 'Стан блокування робочого положення одиниць 65-80',
		'ISOBUS.DDI.372': 'Стан блокування робочого положення одиниць 81-96',
		'ISOBUS.DDI.373': 'Стан блокування робочого положення одиниць 97-112',
		'ISOBUS.DDI.374': 'Стан блокування робочого положення одиниць 113-128',
		'ISOBUS.DDI.375': 'Стан блокування робочого положення одиниць 129-144',
		'ISOBUS.DDI.376': 'Стан блокування робочого положення одиниць 145-160',
		'ISOBUS.DDI.377': 'Стан блокування робочого положення одиниць 161-176',
		'ISOBUS.DDI.378': 'Стан блокування робочого положення одиниць 177-192',
		'ISOBUS.DDI.379': 'Стан блокування робочого положення одиниць 193-208',
		'ISOBUS.DDI.38': 'Обсяг за замовчуванням за час норми внесення',
		'ISOBUS.DDI.380': 'Стан блокування робочого положення одиниць 209-224',
		'ISOBUS.DDI.381': 'Стан блокування робочого положення одиниць 225-240',
		'ISOBUS.DDI.382': 'Стан блокування робочого положення одиниць 241-256',
		'ISOBUS.DDI.383': 'Видимий напрямок вітру',
		'ISOBUS.DDI.384': 'Видима швидкість вітру',
		'ISOBUS.DDI.385': 'MSL атмосферний тиск',
		'ISOBUS.DDI.386': 'Фактичний атмосферний тиск',
		'ISOBUS.DDI.387': 'Всього оборотів в дрібних оборотах',
		'ISOBUS.DDI.388': 'Всього оборотів в повних обертах',
		'ISOBUS.DDI.389': 'Задані обороти вказані як кількість за раз',
		'ISOBUS.DDI.39': 'Мінімальний обсяг за час норми внесення',
		'ISOBUS.DDI.390': 'Фактичні обороти за час',
		'ISOBUS.DDI.391': 'Число обертів за замовчуванням за час',
		'ISOBUS.DDI.392': 'Мінімальні обороти за час',
		'ISOBUS.DDI.393': 'Максимальні обороти за час',
		'ISOBUS.DDI.394': 'Фактичний вміст паливного бака',
		'ISOBUS.DDI.395': 'Фактичний вміст в баку для відпрацьованої рідини дизельного двигуна',
		'ISOBUS.DDI.396': 'Задана швидкість',
		'ISOBUS.DDI.397': 'Фактична швидкість',
		'ISOBUS.DDI.398': 'Мінімальна швидкість',
		'ISOBUS.DDI.399': 'Максимальна швидкість',
		'ISOBUS.DDI.4': 'Мінімальний обсяг норми внесення на площу',
		'ISOBUS.DDI.40': 'Максимальний обсяг норми внесення на площу',
		'ISOBUS.DDI.400': 'Джерело швидкості',
		'ISOBUS.DDI.401': 'Фактичне внесення азоту',
		'ISOBUS.DDI.402': 'Фактичне внесення амонія',
		'ISOBUS.DDI.403': 'Фактичне внесення фосфору',
		'ISOBUS.DDI.404': 'Фактичне внесення калія',
		'ISOBUS.DDI.405': 'Фактичне внесення сухої речовини',
		'ISOBUS.DDI.406': 'Фактичний вміст протеїну',
		'ISOBUS.DDI.407': 'Середній вміст протеїну',
		'ISOBUS.DDI.408': 'Середнє забруднення посівів',
		'ISOBUS.DDI.409': 'Загальна витрата дизельної вихлопної рідини',
		'ISOBUS.DDI.41': 'Задане значення маси за час норми внесення',
		'ISOBUS.DDI.410': 'Миттєва витрата дизельної вихлопної рідини за час',
		'ISOBUS.DDI.411': 'Миттєва витрата дизельної вихлопної рідини на площу',
		'ISOBUS.DDI.412': 'Споживання вихлопної рідини дизельного двигуна протягом усього терміну служби',
		'ISOBUS.DDI.413': 'Середня витрата дизельної вихлопної рідини на час протягом усього терміну служби',
		'ISOBUS.DDI.414': 'Середня витрата дизельної вихлопної рідини на площу протягом всього терміну служби',
		'ISOBUS.DDI.415': 'Фактичний відсоток розділення насіння',
		'ISOBUS.DDI.416': 'Середній відсоток розділення насіння',
		'ISOBUS.DDI.417': 'Фактичний відсоток пропуску насіння',
		'ISOBUS.DDI.418': 'Середній відсоток пропуску насіння',
		'ISOBUS.DDI.419': 'Фактична кількість насіння у відсотках',
		'ISOBUS.DDI.42': 'Фактична масова норма внесення за час',
		'ISOBUS.DDI.420': 'Середній відсоток посівного матеріалу',
		'ISOBUS.DDI.421': 'Фактичне відхилення відстані між насінням',
		'ISOBUS.DDI.422': 'Середне відхилення відстані між насінням',
		'ISOBUS.DDI.423': 'Фактичний коефіцієнт варіації процентної відстані між насінням',
		'ISOBUS.DDI.424': 'Середній коефіцієнт варіації процентної відстані між насінням',
		'ISOBUS.DDI.425': 'Задане значення максимально допустимого відхилення відстані між насінням',
		'ISOBUS.DDI.426': 'Задана притискна сила як сила',
		'ISOBUS.DDI.427': 'Фактична притискна сила як сила',
		'ISOBUS.DDI.428': 'Завантажена повна маса',
		'ISOBUS.DDI.429': 'Вивантажена повна маса',
		'ISOBUS.DDI.43': 'Норма внесення маси на час за замовчуванням',
		'ISOBUS.DDI.430': 'Загальна завантажена маса за весь період',
		'ISOBUS.DDI.431': 'Загальна вивантажена маса за весь період',
		'ISOBUS.DDI.432': 'Встановлене значення витрат азоту',
		'ISOBUS.DDI.433': 'Фактичне значення витрат азоту',
		'ISOBUS.DDI.434': 'Мінімальне значення витрат азоту',
		'ISOBUS.DDI.435': 'Максимальне значення витрат азоту',
		'ISOBUS.DDI.436': 'Встановлена норма внесення амонію',
		'ISOBUS.DDI.437': 'Фактична норма внесення амонію',
		'ISOBUS.DDI.438': 'Мінімальна норма внесення амонію',
		'ISOBUS.DDI.439': 'Максимальна норма внесення амонію',
		'ISOBUS.DDI.44': 'Мінімальна маса за час норми внесення',
		'ISOBUS.DDI.440': 'Встановлене значення витрат фосфору',
		'ISOBUS.DDI.441': 'Фактичне значення витрат фосфору',
		'ISOBUS.DDI.442': 'Мінімальне значення витрат фосфору',
		'ISOBUS.DDI.443': 'Максимальне значення витрат фосфору',
		'ISOBUS.DDI.444': 'Задана норма внесення калію',
		'ISOBUS.DDI.445': 'Фактична норма внесення калію',
		'ISOBUS.DDI.446': 'Мінімальна норма внесення калію',
		'ISOBUS.DDI.447': 'Максимальна норма внесення калію',
		'ISOBUS.DDI.448': 'Встановлена норма витрати сухої речовини',
		'ISOBUS.DDI.449': 'Фактична норма витрати сухої речовини',
		'ISOBUS.DDI.45': 'Максимальна маса за час норми внесення',
		'ISOBUS.DDI.450': 'Мінімальна норма витрати сухої речовини',
		'ISOBUS.DDI.451': 'Максимальна норма витрати сухої речовини',
		'ISOBUS.DDI.452': 'Завантажений загальний об\'єм',
		'ISOBUS.DDI.453': 'Вивантажений загальний об\'єм',
		'ISOBUS.DDI.454': 'Загальний об\'єм завантаження за весь період',
		'ISOBUS.DDI.455': 'Загальний об\'єм вивантаження за весь період',
		'ISOBUS.DDI.456': 'Останній завантажений об\'єм',
		'ISOBUS.DDI.457': 'Останній вивантажений об\'єм',
		'ISOBUS.DDI.458': 'Загальна кількість завантаження',
		'ISOBUS.DDI.459': 'Загальна кількість вивантаження',
		'ISOBUS.DDI.46': 'Кількість даних значень на час норми внесення',
		'ISOBUS.DDI.460': 'Загальна кількість завантаження за весь термін служби',
		'ISOBUS.DDI.461': 'Загальна кількість вивантаження за весь термін служби',
		'ISOBUS.DDI.462': 'Останній завантажений лічильник',
		'ISOBUS.DDI.463': 'Останній вивантажений лічильник',
		'ISOBUS.DDI.464': 'Лічильник перетягування',
		'ISOBUS.DDI.465': 'Кількість циклів за весь термін служби',
		'ISOBUS.DDI.466': 'Фактичний відносний кут з\'єднувача',
		'ISOBUS.DDI.467': 'Фактичний зміст у відсотках',
		'ISOBUS.DDI.468': 'Грунт Сніг / Замерзлий стан',
		'ISOBUS.DDI.469': 'Розрахунковий стан води в грунті',
		'ISOBUS.DDI.47': 'Фактична кількість на час норми внесення',
		'ISOBUS.DDI.470': 'Ущільнення грунту',
		'ISOBUS.DDI.472': 'Задана довжина різання',
		'ISOBUS.DDI.473': 'Мінімальна довжина різання',
		'ISOBUS.DDI.474': 'Максимальна довжина різання',
		'ISOBUS.DDI.475': 'Задане значення гідравлічного тиску тюка',
		'ISOBUS.DDI.476': 'Мінімальне значення гідравлічного тиску тюка',
		'ISOBUS.DDI.477': 'Максимальне значення гідравлічного тиску тюка',
		'ISOBUS.DDI.478': 'Заданий розмір неповного тюка',
		'ISOBUS.DDI.479': 'Мінімальний розмір неповного тюка',
		'ISOBUS.DDI.48': 'Кількість за замовчуванням на час норми внесення',
		'ISOBUS.DDI.480': 'Максимальний розмір неповного тюка',
		'ISOBUS.DDI.481': 'Кількість тюків меншого розміру, які повинні бути включені в один тюк більшого розміру',
		'ISOBUS.DDI.482': 'Кількість тюків меншого розміру, включених в останній вироблений тюк',
		'ISOBUS.DDI.483': 'Задана частота обертання двигуна',
		'ISOBUS.DDI.484': 'Фактична частота обертання двигуна',
		'ISOBUS.DDI.485': 'Мінімальна частота обертання двигуна',
		'ISOBUS.DDI.486': 'Максимальна частота обертання двигуна',
		'ISOBUS.DDI.488': 'Відсотковий рівень в баку для відпрацьованої рідини дизельного двигуна',
		'ISOBUS.DDI.489': 'Максимальний об\'єм паливного бака для вихлопних газів дизельного двигуна',
		'ISOBUS.DDI.49': 'Мінімальна кількість на час норми внесення',
		'ISOBUS.DDI.490': 'Максимальний об\'єм паливного бака',
		'ISOBUS.DDI.491': 'Рівень палива в процентах',
		'ISOBUS.DDI.492': 'Загальна кількість мотогодин',
		'ISOBUS.DDI.493': 'Термін служби двигуна, години',
		'ISOBUS.DDI.494': 'ID партнера останньої події (1-4)',
		'ISOBUS.DDI.495': 'ID партнера останньої події (5-8)',
		'ISOBUS.DDI.496': 'ID партнера останньої події (9-12)',
		'ISOBUS.DDI.497': 'ID партнера останньої події (13-16)',
		'ISOBUS.DDI.498': 'ID партнера останньої події',
		'ISOBUS.DDI.499': 'ID партнера за останньою подією Ідентифікаційний код виробника',
		'ISOBUS.DDI.5': 'Максимальний обсяг норми внесення на площу',
		'ISOBUS.DDI.50': 'Максимальний лічильник на час норми внесення',
		'ISOBUS.DDI.500': 'ID партнера останньої події Клас пристрою',
		'ISOBUS.DDI.501': 'Встановлений обертаючий момент двигуна',
		'ISOBUS.DDI.502': 'Фактичний обертаючий момент двигуна',
		'ISOBUS.DDI.503': 'Мінімальний обертаючий момент двигуна',
		'ISOBUS.DDI.504': 'Максимальний обертаючий момент двигуна',
		'ISOBUS.DDI.505': 'Рівень контролю технологічної колії',
		'ISOBUS.DDI.506': 'Заданий рівень контролю технологічної колії',
		'ISOBUS.DDI.507': 'Порядковий номер технологічної колії',
		'ISOBUS.DDI.508': 'Унікальний ідентифікатор навігаційної опорної лінії A-B',
		'ISOBUS.DDI.509': 'Фактичний номер треку',
		'ISOBUS.DDI.51': 'Задана глибина обробки ґрунту',
		'ISOBUS.DDI.510': 'Номер треку справа',
		'ISOBUS.DDI.511': 'Номер треку зліва',
		'ISOBUS.DDI.512': 'Ширина смуги захоплення навігаційної лінії',
		'ISOBUS.DDI.513': 'Відхилення навігаційної лінії',
		'ISOBUS.DDI.514': 'Якість GNSS',
		'ISOBUS.DDI.515': 'Стан контролю технологічної колії',
		'ISOBUS.DDI.516': 'Збільшена норма для рядів, що примикають до технологічної колії',
		'ISOBUS.DDI.517': 'Задане робоче положення технологічної колії 1-16',
		'ISOBUS.DDI.518': 'Фактичне робоче положення технологічної колії 1-16',
		'ISOBUS.DDI.519': 'Час останнього тюка',
		'ISOBUS.DDI.52': 'Фактична глибина обробки',
		'ISOBUS.DDI.520': 'Фактична висота навісу',
		'ISOBUS.DDI.521': 'Тип установки GNSS',
		'ISOBUS.DDI.522': 'Облік обмотки тюка',
		'ISOBUS.DDI.523': 'Загальна кількість сітчастих тюків',
		'ISOBUS.DDI.524': 'Час обліку обмотки тюка',
		'ISOBUS.DDI.525': 'Загальна кількість упакованих тюків',
		'ISOBUS.DDI.526': 'Фактична температура охолоджуючої рідини',
		'ISOBUS.DDI.528': 'Місткість останнього тюка',
		'ISOBUS.DDI.529': 'Задане значення кута повороту опор грунтообробного диска',
		'ISOBUS.DDI.53': 'Глибина обробки за замовчуванням',
		'ISOBUS.DDI.530': 'Фактичний кут повороту диска грунтообробного диска',
		'ISOBUS.DDI.531': 'Фактичне внесення консерванту на масу врожаю',
		'ISOBUS.DDI.532': 'Встановлене внесення консерванту на масу врожаю',
		'ISOBUS.DDI.533': 'Застосовуваний консервант за замовчуванням на масу врожаю',
		'ISOBUS.DDI.534': 'Мінімальне внесення консерванту на масу врожаю',
		'ISOBUS.DDI.535': 'Максимальне внесення консерванту на масу врожаю',
		'ISOBUS.DDI.536': 'Всього внесено консерванту',
		'ISOBUS.DDI.537': 'Консервант, внесений за весь термін',
		'ISOBUS.DDI.538': 'Середня кількість застосовуваного консерванту на масу врожаю',
		'ISOBUS.DDI.539': 'Фактичний обсяг бака консерванту',
		'ISOBUS.DDI.54': 'Мінімальна глибина обробки',
		'ISOBUS.DDI.540': 'Фактичний рівень консерванту в баку',
		'ISOBUS.DDI.541': 'Фактична швидкість ВВП',
		'ISOBUS.DDI.542': 'Встановлена швидкість ВВП',
		'ISOBUS.DDI.543': 'Швидкість ВВП за замовчуванням',
		'ISOBUS.DDI.544': 'Мінімальна швидкість ВВП',
		'ISOBUS.DDI.545': 'Максимальна швидкість ВВП',
		'ISOBUS.DDI.546': 'Загальний час рубки',
		'ISOBUS.DDI.547': 'Встановлене навантаження на плунжер стиснення тюка',
		'ISOBUS.DDI.548': 'Фактичне навантаження на плунжер стиснення тюка',
		'ISOBUS.DDI.549': 'Останній тюк середнє навантаження на плунжер стиснення тюка',
		'ISOBUS.DDI.55': 'Максимальна глибина обробки',
		'ISOBUS.DDI.550': 'Почвопокровне покриття',
		'ISOBUS.DDI.551': 'Фактичний обертаючий момент ВВП',
		'ISOBUS.DDI.552': 'Встановлений обертаючий момент ВВП',
		'ISOBUS.DDI.553': 'Обертаючий момент ВВП за замовчуванням',
		'ISOBUS.DDI.554': 'Мінімальний обертаючий момент ВВП',
		'ISOBUS.DDI.555': 'Максимальний обертаючий момент ВВП',
		'ISOBUS.DDI.556': 'Поточні погодні умови',
		'ISOBUS.DDI.557': 'Заданий електричний струм',
		'ISOBUS.DDI.558': 'Фактичний електричний струм',
		'ISOBUS.DDI.559': 'Мінімальний електричний струм',
		'ISOBUS.DDI.56': 'Задана глибина висіву',
		'ISOBUS.DDI.560': 'Максимальний електричний струм',
		'ISOBUS.DDI.561': 'Електричний струм за замовчуванням',
		'ISOBUS.DDI.562': 'Задане значення напруги',
		'ISOBUS.DDI.563': 'Напруга за замовчуванням',
		'ISOBUS.DDI.564': 'Фактичне значення напруги',
		'ISOBUS.DDI.565': 'Мінімальне значення напруги',
		'ISOBUS.DDI.566': 'Максимальне значення напруги',
		'ISOBUS.DDI.567': 'Фактичний електричний опір',
		'ISOBUS.DDI.568': 'Встановлена електрична потужність',
		'ISOBUS.DDI.569': 'Фактична електрична потужність',
		'ISOBUS.DDI.57': 'Фактична глибина висіву',
		'ISOBUS.DDI.570': 'Електрична потужність за замовчуванням',
		'ISOBUS.DDI.571': 'Максимальна електрична потужність',
		'ISOBUS.DDI.572': 'Мінімальна електрична потужність',
		'ISOBUS.DDI.573': 'Загальна електрична енергія',
		'ISOBUS.DDI.574': 'Встановлена електрична енергія на одиницю площі норми внесення',
		'ISOBUS.DDI.575': 'Фактична електрична енергія на одиницю площі норми внесення',
		'ISOBUS.DDI.576': 'Максимальна електрична енергія на одиницю площі норми внесення',
		'ISOBUS.DDI.577': 'Мінімальна електрична енергія на одиницю площі норми внесення',
		'ISOBUS.DDI.578': 'Задана температура',
		'ISOBUS.DDI.579': 'Фактична температура',
		'ISOBUS.DDI.58': 'Глибина посіву за замовчуванням',
		'ISOBUS.DDI.580': 'Мінімальна температура',
		'ISOBUS.DDI.581': 'Максимальна температура',
		'ISOBUS.DDI.582': 'Температура за замовчуванням',
		'ISOBUS.DDI.583': 'Задана частота',
		'ISOBUS.DDI.584': 'Фактична частота',
		'ISOBUS.DDI.585': 'Мінімальна частота',
		'ISOBUS.DDI.586': 'Максимальна частота',
		'ISOBUS.DDI.587': 'Попередній дощ',
		'ISOBUS.DDI.588': 'Заданий об\'єм на одиницю площі норми внесення',
		'ISOBUS.DDI.589': 'Фактичний обсяг норми внесення на площу',
		'ISOBUS.DDI.59': 'Мінімальна глибина посіву',
		'ISOBUS.DDI.590': 'Мінімальний об\'єм на площу норми внесення',
		'ISOBUS.DDI.591': 'Максимальний об\'єм на площу норми внесення',
		'ISOBUS.DDI.592': 'Об\'єм за замовчуванням на норму внесення',
		'ISOBUS.DDI.593': 'Тип тяги',
		'ISOBUS.DDI.594': 'Тип рульового управління',
		'ISOBUS.DDI.595': 'Машинний режим',
		'ISOBUS.DDI.596': 'Стан кришки вантажного відсіку',
		'ISOBUS.DDI.597': 'Загальна відстань',
		'ISOBUS.DDI.598': 'Загальна відстані за весь період',
		'ISOBUS.DDI.599': 'Загальна відстань поля',
		'ISOBUS.DDI.6': 'Задана маса на одиницю площі норми внесення',
		'ISOBUS.DDI.60': 'Максимальна глибина посіву',
		'ISOBUS.DDI.600': 'Час загальної відстані поля',
		'ISOBUS.DDI.601': 'Загальна відстань, пройдена по дорозі',
		'ISOBUS.DDI.602': 'Загальна відстань, пройдена вулицями за весь термін',
		'ISOBUS.DDI.603': 'Фактичний робочий стан технологічної колії (17-32)',
		'ISOBUS.DDI.604': 'Фактичний робочий стан технологічної колії (33-48)',
		'ISOBUS.DDI.605': 'Фактичний робочий стан технологічної колії (49-64)',
		'ISOBUS.DDI.606': 'Фактичний робочий стан технологічної колії (65-80)',
		'ISOBUS.DDI.607': 'Фактичний робочий стан технологічної колії (81-96)',
		'ISOBUS.DDI.608': 'Фактичний робочий стан технологічної колії (97-112)',
		'ISOBUS.DDI.609': 'Фактичний робочий стан технологічної колії (113-128)',
		'ISOBUS.DDI.61': 'Задана робоча висота',
		'ISOBUS.DDI.610': 'Фактичний робочий стан технологічної колії (129-144)',
		'ISOBUS.DDI.611': 'Фактичний робочий стан технологічної колії (145-160)',
		'ISOBUS.DDI.612': 'Фактичний робочий стан технологічної колії (161-176)',
		'ISOBUS.DDI.613': 'Фактичний робочий стан технологічної колії (177-192)',
		'ISOBUS.DDI.614': 'Фактичний робочий стан технологічної колії (193-208)',
		'ISOBUS.DDI.615': 'Фактичний робочий стан технологічної колії (209-224)',
		'ISOBUS.DDI.616': 'Фактичний робочий стан технологічної колії (225-240)',
		'ISOBUS.DDI.617': 'Фактичний робочий стан технологічної колії (241-256)',
		'ISOBUS.DDI.618': 'Встановлений робочий стан технологічної колії (17-32)',
		'ISOBUS.DDI.619': 'Встановлений робочий стан технологічної колії (33-48)',
		'ISOBUS.DDI.62': 'Фактична робоча висота',
		'ISOBUS.DDI.620': 'Встановлений робочий стан технологічної колії (49-64)',
		'ISOBUS.DDI.621': 'Встановлений робочий стан технологічної колії (65-80)',
		'ISOBUS.DDI.622': 'Встановлений робочий стан технологічної колії (81-96)',
		'ISOBUS.DDI.623': 'Встановлений робочий стан технологічної колії (97-112)',
		'ISOBUS.DDI.624': 'Встановлений робочий стан технологічної колії (113-128)',
		'ISOBUS.DDI.625': 'Встановлений робочий стан технологічної колії (129-144)',
		'ISOBUS.DDI.626': 'Встановлений робочий стан технологічної колії (145-160)',
		'ISOBUS.DDI.627': 'Встановлений робочий стан технологічної колії (161-176)',
		'ISOBUS.DDI.628': 'Встановлений робочий стан технологічної колії (177-192)',
		'ISOBUS.DDI.629': 'Встановлений робочий стан технологічної колії (193-208)',
		'ISOBUS.DDI.63': 'Робоча висота за замовчуванням',
		'ISOBUS.DDI.630': 'Встановлений робочий стан технологічної колії (209-224)',
		'ISOBUS.DDI.631': 'Встановлений робочий стан технологічної колії (225-240)',
		'ISOBUS.DDI.632': 'Встановлений робочий стан технологічної колії (241-256)',
		'ISOBUS.DDI.634': 'Фактичний об\'єм на відстань Норма внесення',
		'ISOBUS.DDI.635': 'За замовчуванням Об\'єм на відстань Норма внесення',
		'ISOBUS.DDI.636': 'Мінімальний об\'єм на відстань Швидкість нанесення',
		'ISOBUS.DDI.637': 'Максимальний об\'єм на відстань Швидкість нанесення',
		'ISOBUS.DDI.638': 'Заданне значення тиску в шинах',
		'ISOBUS.DDI.639': 'Фактичний тиск в шинах',
		'ISOBUS.DDI.64': 'Мінімальна робоча висота',
		'ISOBUS.DDI.640': 'Тиск у шинах за замовчуванням',
		'ISOBUS.DDI.641': 'Мінімальний тиск в шинах',
		'ISOBUS.DDI.642': 'Максимальний тиск в шинах',
		'ISOBUS.DDI.643': 'Фактична температура шини',
		'ISOBUS.DDI.65': 'Максимальна робоча висота',
		'ISOBUS.DDI.66': 'Задана робоча ширина',
		'ISOBUS.DDI.67': 'Фактична робоча ширина',
		'ISOBUS.DDI.68': 'Робоча ширина за замовчуванням',
		'ISOBUS.DDI.69': 'Мінімальна робоча ширина',
		'ISOBUS.DDI.7': 'Фактична маса на одиницю площі норми внесення',
		'ISOBUS.DDI.70': 'Максимальна робоча ширина',
		'ISOBUS.DDI.71': 'Задане значення змісту об\'єму',
		'ISOBUS.DDI.72': 'Фактичне значення вмісту',
		'ISOBUS.DDI.73': 'Максимальне значення вмісту',
		'ISOBUS.DDI.74': 'Задане значення масового вмісту',
		'ISOBUS.DDI.75': 'Фактичне значення масового вмісту',
		'ISOBUS.DDI.76': 'Максимальне значення масового вмісту',
		'ISOBUS.DDI.77': 'Задане значення лічильника вмісту',
		'ISOBUS.DDI.78': 'Фактичне значення лічильника вмісту',
		'ISOBUS.DDI.79': 'Максимальне значення лічильника вмісту',
		'ISOBUS.DDI.8': 'Норма внесення маси за замовчуванням на площу',
		'ISOBUS.DDI.80': 'Загальний обсяг внесення',
		'ISOBUS.DDI.81': 'Загальна маса внесення',
		'ISOBUS.DDI.82': 'Загальна кількість внесення',
		'ISOBUS.DDI.83': 'Об\'єм врожайності на площу',
		'ISOBUS.DDI.84': 'Маса врожайності на площу',
		'ISOBUS.DDI.85': 'Підрахунок на площу врожаю',
		'ISOBUS.DDI.86': 'Об\'єм за час врожаю',
		'ISOBUS.DDI.87': 'Вихід маси за час',
		'ISOBUS.DDI.88': 'Підрахунок за час врожаю',
		'ISOBUS.DDI.89': 'Загальний об\'єм врожаю',
		'ISOBUS.DDI.9': 'Мінімальна маса на одиницю площі внесення',
		'ISOBUS.DDI.90': 'Загальна маса врожаю',
		'ISOBUS.DDI.91': 'Загальна кількість врожаю',
		'ISOBUS.DDI.92': 'Об\'єм втрат врожаю на площу',
		'ISOBUS.DDI.93': 'Маса втрат врожаю на площу',
		'ISOBUS.DDI.94': 'Кількість втрат врожаю на площу',
		'ISOBUS.DDI.95': 'Об\'єм за час втрати врожаю',
		'ISOBUS.DDI.96': 'Маса за час втрати врожаю',
		'ISOBUS.DDI.97': 'Підрахунок за час втрати врожаю',
		'ISOBUS.DDI.98': 'Відсоток втрати врожаю',
		'ISOBUS.DDI.99': 'Вологість врожаю',
		'ISOBUS.DEVICE_CLASS.0': 'Не вказано',
		'ISOBUS.DEVICE_CLASS.1': 'Трактор',
		'ISOBUS.DEVICE_CLASS.10': 'Зрошення',
		'ISOBUS.DEVICE_CLASS.11': 'Транспорт / Причіп',
		'ISOBUS.DEVICE_CLASS.12': 'Операції ферми',
		'ISOBUS.DEVICE_CLASS.13': 'Допоміжні пристрої з живленням',
		'ISOBUS.DEVICE_CLASS.14': 'Особливі культури',
		'ISOBUS.DEVICE_CLASS.15': 'Земляні роботи',
		'ISOBUS.DEVICE_CLASS.16': 'Трельовочний трактор',
		'ISOBUS.DEVICE_CLASS.17': 'Сенсорні системи',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Лісозаготівельні комбайни',
		'ISOBUS.DEVICE_CLASS.2': 'Обробка грунту',
		'ISOBUS.DEVICE_CLASS.20': 'Експедитори',
		'ISOBUS.DEVICE_CLASS.21': 'Лісонавантажувачі',
		'ISOBUS.DEVICE_CLASS.22': 'Машини для обробки деревини',
		'ISOBUS.DEVICE_CLASS.23': 'Мульчери',
		'ISOBUS.DEVICE_CLASS.24': 'Комунальна техніка',
		'ISOBUS.DEVICE_CLASS.25': 'Машини для внесення рідкого навозу/навозу',
		'ISOBUS.DEVICE_CLASS.26': 'Живильники / Змішувачі',
		'ISOBUS.DEVICE_CLASS.27': 'Культиватори',
		'ISOBUS.DEVICE_CLASS.3': 'Вторинна обробка грунту',
		'ISOBUS.DEVICE_CLASS.4': 'Сівалки',
		'ISOBUS.DEVICE_CLASS.5': 'Добрива',
		'ISOBUS.DEVICE_CLASS.6': 'Обприскувачі',
		'ISOBUS.DEVICE_CLASS.7': 'Комбайни',
		'ISOBUS.DEVICE_CLASS.8': 'Коренезбиральні комбайни',
		'ISOBUS.DEVICE_CLASS.9': 'Корми',
		'JOB.ARCHIVE.QUESTION': 'Ви впевнені що хочете заархівувати це завдання?',
		'JOB.ARCHIVE.SUCCESS': 'Завдання буде заархівовано',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Робота не може бути відображена повністю. Будь-яка інформація вище може бути застарілою і буде перерахована.',
		'JOB.CURRENT_STATUS': 'Поточний статус',
		'JOB.DELETE.QUESTION': 'Ви впевнені що хочете видалити це завдання?',
		'JOB.DELETE.SUCCESS': 'Завдання буде видалено',
		'JOB.DETAILS': 'Деталі завдання',
		'JOB.DRIVER_IMPLEMENT': 'Видалити або змінити водія / обладнання.',
		'JOB.EDIT': 'Редагувати роботу',
		'JOB.REGENERATE': 'Відновити завдання',
		'JOB.REGENERATE.DRIVER': 'Оновити дані водія',
		'JOB.REGENERATE.FIELDS': 'Оновлення даних поля',
		'JOB.REGENERATE.IMPLEMENT': 'Оновити дані обладнання',
		'JOB.REGENERATE.INTRO': 'Якщо дані для виставлення рахунків за машини, навісне обладнання або драйвери змінилися, їх також можна оновити.',
		'JOB.REGENERATE.LOCATIONS': 'Оновлення даних про місцезнаходження',
		'JOB.REGENERATE.MACHINE': 'Оновлення даних машини',
		'JOB.REGENERATE.QUESTION': 'Які дані потрібно оновити?',
		'JOB.REGENERATE.SUCCESS': 'Завдання буде відновлено',
		'JOB.SPLIT': 'Розділити завдання',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Додати час розділення',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Для настройки з точністю до секунди повзунок часу можна також використовувати за допомогою кнопок зі стрілками.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Додайте час, щоб розділити роботу.',
		'JOB.SPLIT.NO_CHANGE': 'Завдання не змінено',
		'JOB.SPLIT.NO_SPLITS': 'Немає часу, обраного для розділення.',
		'JOB.UPDATE': 'Оновити роботу(и)',
		'JOB.WAITING_TIME_UNTIL_READY': 'Залежно від поточного статусу може знадобитися кілька хвилин, перш ніж завдання стане повністю відображено.',
		'JOBS': 'Роботи',
		'JOBS.ALL': 'Всі работи',
		'JOBS.ARCHIVE.PARTIAL': 'Деякі роботи заархівовані.',
		'JOBS.ARCHIVE.QUESTION': 'Ви дійсно хочете заархівувати вибрані роботи?',
		'JOBS.ARCHIVE.SUCCESS': 'Роботи будуть заархівовані',
		'JOBS.CREATE_TASK': 'Створити завдання',
		'JOBS.DELETE.QUESTION': 'Ви дійсно хочете видалити вибрані завдання? Всі дані про завдання будуть видалені безповоротно.',
		'JOBS.DELETE.SUCCESS': 'Робочі місця будуть видалені',
		'JOBS.DELETED.FAILURE': 'Не вдалося видалити деякі роботи',
		'JOBS.EDIT': 'Редагувати роботи',
		'JOBS.EDIT.SUCCESS': 'Роботи будуть відредаговані',
		'JOBS.IN_TASK': 'Роботи в завданнях',
		'JOBS.MERGE.SUCCESS': 'Завдання будуть об\'єднані',
		'JOBS.MERGING': 'Об\'єднати роботи',
		'JOBS.NO': 'Немає робіт',
		'JOBS.NOT_SELECTED': 'Немає обраних завдань',
		'JOBS.REGENERATE': 'Відновити роботи',
		'JOBS.REGENERATE.SUCCESS': 'Роботи будуть відновлені',
		'JOBS.SELECTED': 'Вибрані роботи',
		'JOBS.TASK_CREATED': 'Завдання успішно створено',
		'JOBS.UPDATE.SUCCESS': 'Оновити роботу(и)',
		'JOBS.WITHOUT_TASK': 'Роботи без завдання',
		'JOBS.WITH_TASK': 'Роботи в завданні',
		'KILOMETERS': 'Кілометри',
		'LANGUAGE': 'Мова',
		'LANGUAGE.ADD': 'Додати мову',
		'LANGUAGE.CODE': 'Код мови',
		'LANGUAGE.DEFAULT': 'Мова за замовчуванням',
		'LASTNAME': 'Прізвище',
		'LAST_ONLINE': 'Останній раз онлайн',
		'LAST_UPDATED': 'Останнє оновлення',
		'LATITUDE': 'Широта',
		'LOAD.MORE': 'Завантажити більше',
		'LOADS': 'Навантаження',
		'LOCATION': 'Місцезнаходження',
		'LOCATION.ADD': 'Додати розташування',
		'LOCATION.ADD.SUCCESS': 'Місцезнаходження успішно додано',
		'LOCATION.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати місцезнаходження?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Місцезнаходження успішно деактивовано',
		'LOCATION.DELETE.QUESTION': 'Ви дійсно хочете видалити місце розташування?',
		'LOCATION.DELETE.SUCCESS': 'Місцезнаходження успішно видалено',
		'LOCATION.DETAILS': 'Деталі місцезнаходження',
		'LOCATION.DRAW.START': 'Відзначити місце розташування на карті!',
		'LOCATION.EDIT.SUCCESS': 'Місцезнаходження успішно відредаговано',
		'LOCATIONS': 'Місцеположення',
		'LOCATIONS.ALL': 'Всі місцеположення',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Деякі з локацій не вдалося деактивувати.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати локації?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Локації успішно деактивовано',
		'LOCATIONS.DELETE.FAILURE': 'Не вдалося видалити деякі місця розташування',
		'LOCATIONS.DELETE.QUESTION': 'Ви дійсно хочете видалити вибрані місця?',
		'LOCATIONS.DELETE.SUCCESS': 'Місця розташування успішно видалені',
		'LOCATIONS.NO': 'Немає місць розташування',
		'LOCATIONS.NOT_SELECTED': 'Немає вибраних місць розташувань',
		'LOCATIONS.REACTIVATE.FAILURE': 'Деякі з локацій не вдалося відновити.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Ви дійсно хочете реактивувати вибрані локації?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Локації успішно відновлені',
		'LOCATIONS.SELECTED': 'Вибрані місця розташування',
		'LOG': 'Журнал повідомлень',
		'LOGIN': 'Увійти',
		'LOGIN.NOT_UNLOCKED_YET': 'Ще не розблоковано?',
		'LOGIN.NO_ACCOUNT_YET': 'Ще немає облікового запису?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Забули пароль?',
		'LOGIN.REGISTER': 'Зареєструватися',
		'LOGIN.REMEMBER_PASSWORD': 'Нагадати пароль',
		'LOGIN.UNLOCK': 'Розблокувати',
		'LOG_OUT': 'Вийти',
		'LONGITUDE': 'Довгота',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Змінити пароль',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Будь ласка, введіть код активації, який ви отримали по електронній пошті.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Будь ласка, введіть тут свою адресу електронної пошти.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Будь ласка, введіть дійсну адресу електронної пошти.',
		'MAC': 'MAC',
		'MACHINE': 'Машина',
		'MACHINE.ADD': 'Додати машину',
		'MACHINE.ADD.SUCCESS': 'Машина додана',
		'MACHINE.DELETE.QUESTION': 'Ви дійсно хочете видалити машину?',
		'MACHINE.DELETE.SUCCESS': 'Машина успішно видалена',
		'MACHINE.DETAILS': 'Деталі машини',
		'MACHINE.EDIT': 'Додати машину',
		'MACHINE.EDIT.SUCCESS': 'Машина успішно відредагована',
		'MACHINE.INTERVAL.ADD': 'Додати машинний інтервал',
		'MACHINE.LIVE_STATUS': 'Статус машини',
		'MACHINE.NO': 'Немає машини',
		'MACHINE.RELOAD_POSITIONS': 'Перезавантажте позиції машини',
		'MACHINE.STATUS': 'Стан машини',
		'MACHINES': 'Машини',
		'MACHINES.ALL': 'Всі машини',
		'MACHINES.DEACTIVATE.FAILURE': 'Деякі з машин не вдалося деактивувати.',
		'MACHINES.DEACTIVATE.QUESTION': 'Ви дійсно хочете деактивувати вибрані машини?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Машини успішно деактивовано',
		'MACHINES.DELETE.FAILURE': 'Деякі машини не можуть бути видалені',
		'MACHINES.DELETE.QUESTION': 'Ви дійсно хочете видалити вибрані машини?',
		'MACHINES.DELETE.SUCCESS': 'Машини успішно видалені',
		'MACHINES.MANAGEMENT': 'Керування машинами',
		'MACHINES.NO': 'Немає машин',
		'MACHINES.NOT_SELECTED': 'Немає обраних машин',
		'MACHINES.NO_LICENSE.WARNING': 'Пристрій не має доданої ліцензії. Без ліцензії дані не будуть записані.',
		'MACHINES.REACTIVATE.FAILURE': 'Деякі з машин не вдалося реанімувати.',
		'MACHINES.REACTIVATE.QUESTION': 'Ви дійсно хочете активувати вибрані машини?',
		'MACHINES.REACTIVATE.SUCCESS': 'Машини успішно реанімовані',
		'MACHINES.SELECTED': 'Вибрані машини',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Машина / обладнання',
		'MAC_DEVICES': 'Пристрої, підключені до машини',
		'MAINTENANCE': 'Технічне обслуговування',
		'MAINTENANCE.AMOUNT': 'Cума обслуговування',
		'MAINTENANCE.PERIOD': 'Період обслуговування',
		'MAKE': 'Робити',
		'MANURE': 'Гній',
		'MANURE.TYPE': 'Тип гною',
		'MAP': 'Карта',
		'MAP.SECTION': 'Розділ карти',
		'MAP.SECTION.CHANGE': 'Змінити розділ мапи',
		'MARKER.ADD': 'Додати новий маркер',
		'MARKER.EDIT.BORDERS': 'Змінити межі',
		'MARKER.ENTRANCE': 'Вхід',
		'MARKER.EXIT': 'Вихід',
		'MARKER.INFO': 'Інформація',
		'MARKER.WARN': 'Попереджати',
		'MAX': 'Максе.',
		'MAX_VALUE': 'Максимальне значення',
		'MERGE': 'Об\'єднати',
		'MESSAGES.NO': 'Немає повідомлень',
		'MILEAGE': 'Пробіг',
		'MILEAGE.INVALID': 'Невірний пробіг',
		'MIN': 'Min',
		'MIN_VALUE': 'Мінімальне значення',
		'MOBILE': 'Мобільний',
		'MODE.SWITCH': 'Переключити режим',
		'MODEL': 'Модель',
		'MYPROFILE': 'Мій профіль',
		'MYPROFILE.BASIC_DATA': 'Основні дані',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Ваші основні дані були змінені.',
		'NAME': 'Ім\'я',
		'NAV.ACTIVITIES': 'Заходи',
		'NAV.ADMIN': 'Адміністратор',
		'NAV.ADMIN.DASHBOARD': 'Приладова панель',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Перегляд вакансій',
		'NAV.ADMIN.USERS': 'Керування користувачами',
		'NAV.CUSTOMERS': 'Користувачі',
		'NAV.DASHBOARD': 'Приладова панель',
		'NAV.DATA_PREPARATION': 'Підготовка данних',
		'NAV.EMPLOYEES': 'Співробітники',
		'NAV.ENTERPRISE': 'Компанія',
		'NAV.FIELDS': 'Поля',
		'NAV.FILE_TRANSFER': 'ISO Taskdata',
		'NAV.HARDWARE': 'Апаратне забезпечення',
		'NAV.HARDWARE_SETUP': 'Налаштування обладнання',
		'NAV.IMPLEMENTS': 'Обладнання',
		'NAV.LOCATIONS': 'Місця розташування',
		'NAV.MACHINES': 'Машини',
		'NAV.MY_SECTION': 'Мій розділ',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Партнер',
		'NAV.SETTINGS': 'Налаштування',
		'NAV.SETTINGS.ADAPTER': 'Адаптер',
		'NAV.SETTINGS.GENERAL': 'Компанія',
		'NAV.SETTINGS.PARTNER': 'Партнер',
		'NAV.STATISTIC': 'Статистика',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Виправити переклад',
		'NAV.TRANSLATION_MANAGEMENT': 'Управління перекладом',
		'NETWORK.ACCESS_TECHNOLOGY': 'Технологія доступу',
		'NETWORK.OPERATOR': 'Оператор',
		'NEXT': 'Наступний',
		'NO': 'Ні',
		'NONE': 'Ні',
		'NOTICE': 'Примітка',
		'NON_PRODUCTIVE_TIME': 'Непродуктивний час',
		'NON_PRODUCTIVE_TIMES': 'Непродуктивний час',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Не читається.',
		'NO_DATA': 'Немає даних',
		'ONLY_ON': 'Тільки на',
		'OPACITY': 'Затененность',
		'OPERATING_HOURS': 'Години роботи',
		'OPERATING_HOURS.INVALID': 'Години роботи недійсні',
		'OPERATION': 'Операція',
		'OPERATION.NOT_SELECTED': 'Немає обраних операцій на полі',
		'OPERATION.SELECT': 'Вибрати операцію',
		'OPERATIONS': 'Операції',
		'OPERATIONS.ARRIVAL': 'Прибуття',
		'OPERATIONS.CUSTOMER': 'Операції для клієнта',
		'OPERATIONS.FIELD': 'Операції на полі',
		'OPERATIONS.FIELDS': 'Операції на полях',
		'OPERATIONS.FIELD_TIME': 'Час на полі',
		'OPERATIONS.GEOMETRY': 'Геометрія',
		'OPERATIONS.LOCATION': 'Операції в місці розташування',
		'OPERATIONS.LOCATIONS': 'Операції в місцях розташування',
		'OPERATIONS.NO': 'Немає операцій',
		'OPERATIONS.PREPARATION': 'Підготовка',
		'OVERRIDE.NO': 'Без перевизначення',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'За сторінку',
		'PAGINATION.TOTAL': 'всього',
		'PAGINATOR.FIRST_PAGE': 'Перша сторінка',
		'PAGINATOR.ITEMS_PER_PAGE': 'Елементи на сторінці',
		'PAGINATOR.LAST_PAGE': 'Остання сторінка',
		'PAGINATOR.NEXT_PAGE': 'Наступна сторінка',
		'PAGINATOR.OF': 'з',
		'PAGINATOR.PREVIOUS_PAGE': 'Попередня сторінка',
		'PARTNER_CONNECTION': 'Партнерський зв\'язок',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Не закінчується',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Закінчується',
		'PASSWORD': 'Пароль',
		'PASSWORD.CHANGE': 'Змінити пароль',
		'PASSWORD.CHANGE.ACTIVATE': 'Поточний пароль',
		'PASSWORD.CHANGE.SUCCESS': 'Пароль успішно змінено',
		'PASSWORD.CONFIRM': 'Підтвердіть новий пароль',
		'PASSWORD.LENGTH.REQUIRED': 'Пароль повинен бути не менше 6 символів',
		'PASSWORD.NEW_PASSWORD': 'Новий пароль',
		'PASSWORD.NO_MATCH': 'Невідповідність підтвердження пароля!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Середня продуктивність',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Це значення також враховує всі робочі стани, включаючи підготовку та час у дорозі',
		'PERFORMANCE.AVERAGE.FIELD': 'Середня продуктивність (поле)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Це значення враховує лише роботу на полі, очікування на полі та ввімкнення поля',
		'PERFORMANCE.TOTAL': 'Загальна продуктивність',
		'PHONE': 'Контактний номер телефону',
		'PHONE.INVALID': 'Телефон недійсний',
		'PHONE_MOBILE': 'Телефон (мобільний)',
		'PH_VALUE': 'Значення PH',
		'PLAY': 'Play',
		'POSTCODE': 'Поштовий індекс',
		'PREVIOUS': 'Попередній',
		'PROCESS': 'Процесс',
		'PROCESSED': 'Оброблено',
		'PROCESSED.FAILURE': 'Збій при обробці',
		'PROCESSED.SUCCESSFULL': 'Успішно оброблено',
		'PRODUCT': 'Продукт',
		'PROGRESS': 'Прогрес',
		'PROJECTION': 'Проекція',
		'RAW_DATA': 'Необроблені дані',
		'RECEIVED.AT': 'Отримано в',
		'REGENERATE': 'Відновити',
		'REGENERATE.SELECTED': 'Відновити вибране',
		'REGISTER': 'Зареєструватися',
		'REGISTER.ALREADY_REGISTERED?': 'Вже зареєстровані?',
		'REGISTER.I_ACCEPT_THE': 'Я приймаю',
		'RELOAD': 'Перезавантажити',
		'REMOVE': 'Видалити',
		'RENEW': 'Відновити',
		'REOCURRING': 'Виправлення',
		'REPORT': 'Звіт',
		'RESET': 'Скидання налаштувань',
		'RESOLUTION': 'Розширення',
		'RESTORE.DRIVER': 'Відновити драйвер',
		'RESTORE.IMPLEMENT': 'Відновлення знаряддя',
		'ROAD': 'Дорога',
		'ROLE': 'Роль',
		'RUNTIME_H': 'Час роботи в годинах',
		'SAFETY_CHECK': 'Перевірка безпеки',
		'SATELITE': 'Супутник',
		'SAVE': 'Зберегти',
		'SCALE.TYPE': 'Тип шкали',
		'SEARCH': 'Пошук',
		'SEASON_YEAR': 'Сезон',
		'SEASON_YEAR.START': 'Початок сезону',
		'SELECT.ALL': 'Вибрати все',
		'SELECT.CLEAR': 'Зняти виділення',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Дані датчика',
		'SENSORDATA.DESCRIPTION': 'Візуалізація даних датчика',
		'SENSORDATA.SELECT_SENSOR': 'Вибрати датчик',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Показати кольори робочого стану',
		'SENSOR_PARAMETER': 'Параметр датчика',
		'SENSOR_PARAMETER.ADD': 'Додати параметр датчика',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Визначте індивідуальні параметри датчика для вибраного обладнання.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Визначте індивідуальний параметр датчика.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Індивідуальний параметр датчика.',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Параметр датчика використовується в іншій конфігурації параметра',
		'SENSOR_PARAMETERS': 'Параметри датчика',
		'SENSOR_PARAMETERS.NO': 'Немає параметрів датчика',
		'SERIAL': 'Серійний номер',
		'SETTINGS': 'Налаштування',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Ваш аккаунт Agrirouter можна підключити до exatrek для обміну даними.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter підключений і готовий до використання. Підключення дійсно до',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Підключення до партнерів exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Синхронізуйте поля з 365farmnet з exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Синхронізуйте обладнання з 365farmnet з exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Синхронізуйте машини з 365farmnet з exatrek',
		'SETTINGS.GO_TO_FARMNET': 'Перейти к 365 FARMNET',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'Синхронізацію з 365farmnet можна використовувати тільки з веб-додатку 365farmnet.',
		'SHOW': 'Показати',
		'SHOW_DIRECTION': 'Показати напрямки',
		'SHOW_EVENTS': 'Показати заходи',
		'SHOW_FIELDS': 'Показати поля',
		'SHOW_LOCATIONS': 'Показати місця розташування',
		'SHOW_OFFLINE_MACHINES': 'Показати машини оффлайн',
		'SHOW_TRACKS': 'Показати маршрути',
		'SHOW_TRACKS_': 'Показати маршрути',
		'SNACKBAR.DAYS': 'Дні',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Термін дії вашої ліцензії закінчується через',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Принаймні одна машина якийсь час була не в мережі!',
		'SORT_BY': 'Відсортовано по',
		'SPEED': 'Швидкість',
		'SPEED.AVERAGE': 'Середня швидкість',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Перевищення швидкості',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Розділення',
		'START': 'Почати',
		'STATISTICS': 'Statistics',
		'STATUS': 'Статус',
		'STOP': 'Стоп',
		'STORAGE': 'Зберігання',
		'STORAGE.USB': 'USB-накопичувач',
		'STORAGE.USB.USED': 'Використовуваний USB-накопичувач',
		'STORAGE.USED': 'Використане сховище',
		'SYMBOLIZATION': 'Символізація',
		'TASK': 'Завдання',
		'TASK.ADDABLE_JOBS': 'Роботи, що додаються',
		'TASK.ADD_JOBS': 'Додати роботу до задачі',
		'TASK.ARCHIVED_JOB_WARNING': 'Це завдання містить заархівовані роботи і не буде відображатися повністю!',
		'TASK.DELETE.JOB.FAILURE': 'У задачі повинна бути хоча б одна робота!',
		'TASK.DELETE.JOB.QUESTION': 'Ви дійсно хочете видалити завдання?',
		'TASK.DELETE.JOB.SUCCESS': 'Робота успішно видалена з завдання',
		'TASK.DELETE.QUESTION': 'Ви дійсно хочете видалити завдання?',
		'TASK.DELETE.SUCCESS': 'Завдання успішно видалено',
		'TASK.EDIT': 'Редагувати задачу',
		'TASK.EDIT.SUCCESS': 'Завдання успішно відредаговано',
		'TASK.EXPORT_DETAILS': 'Експортуйте вибране завдання',
		'TASK.JOBS_TO_ADD': 'Роботи до додаванню',
		'TASK.NEW': 'Нове завдання',
		'TASKS': 'Завдання',
		'TASKS.NO': 'Немає завдань',
		'TASK_CONTROLLER.ACTIVE': 'Активний контролер завдань (DataLog)',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Режим сумісності контролера завдань',
		'TAX_ID': 'ІПН',
		'TC': 'TaskController',
		'TC.ACTIVE': 'TC active',
		'TC.TC_COMP': 'TC comp.',
		'TERMINAL.NO': 'Термінал відсутній',
		'TERMINAL.TYPE': 'Тип терминалу',
		'TEST.SUCCESS': 'Запит виконаний успішно. Скоро ви отримаєте електронного листа.',
		'TIME': 'Час',
		'TIME.REMAINING': 'Час, що залишився',
		'TIMEZONE': 'Часовий пояс',
		'TITLE': 'Запросити тестовий аккаунт',
		'TOKEN': 'Код доступу',
		'TOTAL': 'Загальний',
		'TRACKS.LOADING': 'Завантаження маршрутів...',
		'TRACK.WIDTH': 'Ширина колії',
		'TRACK.WIDTH.NARROW': 'Вузький',
		'TRACK.WIDTH.NORMAL': 'Нормально',
		'TRACK.WIDTH.WIDE': 'Широкий',
		'TRACK_LENGTH': 'Довжина шляху',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Перекладається',
		'TRANSLATABLE.ADD': 'Додати перекладний',
		'TRANSLATION': 'Переклад',
		'TRANSPORT': 'Транспорт',
		'TRANSPORT/AXLES': 'Транспорт / Вісі',
		'TRANSPORTAMOUNT_AXLES': 'Кількість транспорту / Вісі',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Тип',
		'UNDO': 'Відміна',
		'UNIT': 'Одиниця виміру',
		'UNKNOWN': 'Невідомо',
		'UNTIL': 'до тих пір, поки',
		'UPLOAD': 'Завантажити',
		'UPLOAD.FINISHED': 'Завантаження завершено',
		'UPLOADING': 'Завантаження',
		'USER.EDIT.SUCCESS': 'Користувач успішно відредагований',
		'USERNAME': 'Ім\'я користувача',
		'USERNAME.LENGTH.REQUIRED': 'Ім\'я користувача має бути не менше 6 символів.',
		'USERNAME.TAKEN': 'Таке ім\'я вже існує',
		'USERNAME.VALID.CHARS': 'Ім\'я користувача може містити тільки літери, цифри, «-» та «_».',
		'USERROLE': 'Роль користувача',
		'USERSTATUS': 'Статус користувача',
		'USER_CREATED': 'Користувача створено',
		'WAITING': 'Очікування',
		'WARNING': 'Попередження',
		'WEEK.CURRENT': 'Поточний тиждень',
		'WEEK.NEXT': 'Наступний тиждень',
		'WEEK.PREVIOUS': 'Попередній тиждень',
		'WEEK.SELECTED': 'Вибраний тиждень',
		'WEIGHING': 'Зважування',
		'WIDTH.INVALID': 'Неприпустима ширина',
		'WORKING_HOURS': 'Робочі години',
		'WORKING_TIME': 'Робочий час',
		'WORKING_WIDTH': 'Робоча ширина',
		'WORKSTATE': 'Робочий стан',
		'WORKSTATES': 'Робочі стани',
		'YES': 'Так',
    'NO_POSITION_MACHINE_FOUND': 'No position machine found',
	}
};
